import firebase from './firebase.js';
import constants from './constants';
import RequestManager from './requestManager.js';
import history from './history';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import imageCompression from 'browser-image-compression';
import { StateManager } from './stateManager.js';
import { PHONE_SOURCE, callbackQueueRows, callsForThread, rosterPerson, sortThreads } from '../pages/PhonePage/phone';
import { CAR_SOLD_OTHER_BUYER } from './leadStatus';
import { isOpenServiceLine, serviceLineIssue } from './partServiceLine';

// import klaviyo from './klaviyo.js';
// import Geocode from 'react-geocode';
// import ReactPixel from 'react-facebook-pixel';
// import MomentUtils from '@date-io/moment';
// const moment = new MomentUtils();

class Store{
  constructor(){
    this.deal = {};
    this.customer = {};
    this.trades = [];
    this.coBuyer = {};
  }

  update = (location, e) => {
    // console.log(location, e)
    // console.log(e)
    let object = this[location] || {};
    object[e.id || e.name] =  e.value;
    // console.log(object)
    this[location] = object;
  };

  updateArray = (location, arrayName, e) => {
    // console.log(1, this[location])
    // console.log(e)
    let object = this[location] || {};
    // console.log(e)
    e.id = e.id.split("-")[0]
    object[arrayName] =  object[arrayName] || [];
    object[arrayName][e.index] = object[arrayName][e.index] || {}
    object[arrayName][e.index][e.id] = e.value
    this[location] = object;
    // console.log(this[location])
  };

  clearForm = () => {
    for (const id in this.activeFormSetter) this.activeFormSetter[id]('');
  }

  uploadFiles = async (collection, form) => {
    const { files = [] } = form;
    for(let i = 0; i < files.length; i++) {
      const file = files[i];
      const [name = "", ext = ""] = (form.name || file.name).split(".");
      const fileName = uuidv4()+"."+ext;
      const storageRef = firebase.storage().ref('files/'+fileName);
      await storageRef.put(file);
      await firebase.firestore().collection(collection).doc(fileName).set({
        name: form.name || file.name || fileName,
        date: form.date, 
        stock: form.stock,
      }); 
    }
    
    // TODO: add more flexible callback support
    if(this.form.callback) this.form.callback(form.stock)
    return {complete: true};
  }

  uploadForms = async (collection, form) => {
    const iterable = [...form[form.iterable]];
    delete form[form.iterable]
    delete form.iterable
    //TODO: add docID to forms in order to update documents
    for (let i = 0; i < iterable.length; i++) {
      const item = iterable[i];
      const newform = {...form, ...item};
      await this.uploadForm(collection, newform, newform);
      
    }
    
    // TODO: add more flexible callback support
    if(this.form.callback) this.form.callback(form.stock)
    return {complete: true};
  }

  uploadForm = async (collection, form, callbackParams = null) => {
    // const delay = ms => new Promise(res => setTimeout(res, ms));
    // await delay(3000);
    // this.clearForm();
    // return {complete: true};
    const folder = form.folder || "receipts";
    console.log(collection, form);
    if(!collection || !form) return {complete: false};
    form.date = !!form.date ? form.date : moment().format('YYYY/MM/DD');
    //Trims string values, and coerces any moment/Date objects to 'YYYY/MM/DD'
    //strings so a raw moment object can never be serialized into Firestore
    //(serialized moment objects broke preparePDF's date formatting).
    Object.keys(form).forEach(key => {
      const value = form[key];
      if (typeof value === 'string') form[key] = value.trim();
      else if (moment.isMoment(value)) form[key] = value.format('YYYY/MM/DD');
      else if (value instanceof Date) form[key] = moment(value).format('YYYY/MM/DD');
    });
    // VINs are always stored upper-cased.
    if (typeof form.vin === 'string') form.vin = form.vin.toUpperCase();
    const { files = [] } = form;

    let fileNames = []
    for(let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileName = uuidv4();
      const location = `${folder}/${fileName}`;
      fileNames = [...fileNames, location];
      const storageRef = firebase.storage().ref(location);
      await storageRef.put(file);//.then((snapshot) => console.log('Uploaded a blob or file!'));
    }

    if(fileNames.length > 0) form.files = fileNames;
    const db = firebase.firestore();
    if(this.form.docID){
      const defaultID = form[this.form.docID];
      await db.collection(collection).doc(defaultID).set(form, {merge: true});
    }
    else{ 
      await db.collection(collection).doc().set(form);
    }

    let response = {complete: true}
    if(this.form.callback) response = this.form.callback(callbackParams) || response;
    console.log(response)

    return response;
  }

  // ─── Document Library ──────────────────────────────────────────────
  // Files live in Storage at `files/{uuid.ext}` and as Firestore docs in the
  // `files` collection. Each doc carries rich metadata + polymorphic entity
  // links. `linkKeys` (flat "type:id" strings) powers array-contains queries
  // so a file can surface inside any linked car / customer / service order.

  fileExt = (filename = '') => {
    const parts = String(filename).split('.');
    return parts.length > 1 ? parts.pop() : '';
  };

  buildLinkKeys = (links = []) => links.map(l => `${l.type}:${l.id}`);

  // Upload a single file with progress. meta: { category, tags, links }.
  // onProgress receives 0–100. Returns the created file doc (with id).
  uploadLibraryFile = async (file, meta = {}, onProgress) => {
    const ext = this.fileExt(file.name);
    const id = ext ? `${uuidv4()}.${ext}` : uuidv4();
    const storageRef = firebase.storage().ref(`files/${id}`);

    await new Promise((resolve, reject) => {
      const task = storageRef.put(file);
      task.on(
        'state_changed',
        snap => {
          if (onProgress && snap.totalBytes) {
            onProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100));
          }
        },
        reject,
        resolve
      );
    });

    const links = meta.links || [];
    const doc = {
      name: file.name,
      date: moment().format('YYYY/MM/DD'),
      size: file.size || 0,
      contentType: file.type || '',
      category: meta.category || 'other',
      tags: meta.tags || [],
      links,
      linkKeys: this.buildLinkKeys(links),
      // Legacy single-car field, kept populated for back-compat with old `files` queries.
      stock: (links.find(l => l.type === 'car') || {}).id || '',
      uploadedBy: StateManager.userID || '',
      uploadedByName: StateManager.userName || '',
      uploadedAt: Date.now(),
    };

    // Bills enter the Bills workflow as outstanding until marked complete.
    if (doc.category === 'bill') doc.billStatus = 'outstanding';

    await firebase.firestore().collection('files').doc(id).set(doc);
    return { id, ...doc };
  };

  updateLibraryFile = async (id, updates = {}) => {
    const patch = { ...updates };
    if (updates.links) {
      patch.linkKeys = this.buildLinkKeys(updates.links);
      patch.stock = (updates.links.find(l => l.type === 'car') || {}).id || '';
    }
    await firebase.firestore().collection('files').doc(id).update(patch);
    return patch;
  };

  deleteLibraryFile = async (id) => {
    await firebase.firestore().collection('files').doc(id).delete();
    try {
      await firebase.storage().ref(`files/${id}`).delete();
    } catch (err) {
      console.warn('Storage delete failed (may not exist):', err);
    }
  };

  // Fetch files linked to an entity. Combines the new linkKeys array-contains
  // query with the legacy `stock ==` query (for files created before linkKeys),
  // then dedupes by doc id.
  getEntityFiles = async ({ type, id, legacyStock }) => {
    const db = firebase.firestore();
    const key = `${type}:${id}`;
    const queries = [db.collection('files').where('linkKeys', 'array-contains', key).get()];
    if (legacyStock) {
      queries.push(db.collection('files').where('stock', '==', legacyStock).get());
    }
    const snaps = await Promise.all(queries);
    const byId = {};
    snaps.forEach(snap => snap.docs.forEach(d => { byId[d.id] = { id: d.id, ...d.data() }; }));
    return Object.values(byId);
  };

  getFileDownloadURL = async (id) => firebase.storage().ref(`files/${id}`).getDownloadURL();

  // ─── Bills workflow ────────────────────────────────────────────────
  // Bills are library files with category 'bill'. They carry a billStatus
  // (outstanding | complete) plus AI-extracted fields (billVendor, billAmount,
  // billDueDate, billInvoiceNumber, billAccountNumber, billLinks, billSummary).

  // The buyer's agora title tracker for this car, or null. Only the backend
  // writes titleTrackers (see skyway-functions title_tracker).
  getTitleTracker = async (stockNumber) => {
    const snap = await firebase.firestore().collection('titleTrackers').where('stock', '==', stockNumber).limit(1).get();
    return snap.empty ? null : { token: snap.docs[0].id, ...snap.docs[0].data() };
  };

  getBills = async () => {
    const snap = await firebase.firestore().collection('files').where('category', '==', 'bill').get();
    const bills = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    bills.sort((a, b) => (b.uploadedAt || 0) - (a.uploadedAt || 0));
    return bills;
  };

  setBillStatus = async (id, status) => {
    const patch = { billStatus: status };
    if (status === 'complete') {
      patch.billCompletedAt = Date.now();
      patch.billCompletedBy = StateManager.userID || '';
      patch.billCompletedByName = StateManager.userName || '';
    } else {
      patch.billCompletedAt = null;
      patch.billCompletedBy = '';
      patch.billCompletedByName = '';
    }
    await firebase.firestore().collection('files').doc(id).update(patch);
    return patch;
  };

  // Edit extracted bill fields (vendor/amount/due date/etc.).
  updateBill = async (id, fields = {}) => {
    await firebase.firestore().collection('files').doc(id).update(fields);
    return fields;
  };

  // Run AI extraction on a bill via the extractBill Cloud Function. Returns
  // { success, fields }. The function also persists the fields to the doc.
  extractBill = async (id) => {
    try {
      return await RequestManager.post({ function: 'extractBill', variables: { id } });
    } catch (err) {
      console.warn('extractBill failed:', err);
      return { success: false };
    }
  };

  // ─── Ron Check-In ──────────────────────────────────────────────────
  // Batches of Ron's-Classic-Cars bills-of-sale. A batch becomes a persisted
  // `ronBatches` doc the moment files are dropped (status 'draft') and survives
  // reloads until it is generated/sent (status 'sent') or deleted. BOS images
  // live in Storage at `ron_checkin/{batchId}/{entryId}.jpg`.

  createRonBatch = async () => {
    const ref = firebase.firestore().collection('ronBatches').doc();
    const now = Date.now();
    const doc = {
      status: 'draft',
      entries: [],
      createdBy: StateManager.userID || '',
      createdByName: StateManager.userName || '',
      createdAt: now,
      updatedAt: now,
      sentAt: null,
      sentTo: null,
    };
    await ref.set(doc);
    return { id: ref.id, ...doc };
  };

  updateRonBatch = async (id, patch = {}) => {
    await firebase.firestore().collection('ronBatches').doc(id)
      .set({ ...patch, updatedAt: Date.now() }, { merge: true });
  };

  getRonBatches = async () => {
    const snap = await firebase.firestore().collection('ronBatches')
      .orderBy('createdAt', 'desc').get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  // Drafts: delete the batch's BOS images then the doc. Sent batches: delete the
  // record only — issued checks are not voided (they were already created/emailed).
  deleteRonBatch = async (batch) => {
    if (batch.status !== 'sent') {
      const entries = batch.entries || [];
      for (const entry of entries) {
        if (!entry.imagePath) continue;
        try {
          await firebase.storage().ref(entry.imagePath).delete();
        } catch (err) {
          console.warn('Ron BOS image delete failed (may not exist):', err);
        }
      }
    }
    await firebase.firestore().collection('ronBatches').doc(batch.id).delete();
  };

  // Upload a BOS image file. HEIC/HEIF are converted to JPEG server-side (so they
  // can be previewed in the browser). Returns the final Storage path + download URL.
  uploadRonBosImage = async (batchId, entryId, file) => {
    const ext = (this.fileExt(file.name) || 'jpg').toLowerCase();
    let path = `ron_checkin/${batchId}/${entryId}.${ext}`;
    await firebase.storage().ref(path).put(file);

    if (['heic', 'heif'].includes(ext)) {
      try {
        const data = await RequestManager.post({
          function: 'convertHeicToJpeg',
          variables: { storagePath: path },
        });
        if (data && data.success && data.jpegPath) path = data.jpegPath;
      } catch (err) {
        console.warn('HEIC convert failed:', err);
      }
    }

    const url = await firebase.storage().ref(path).getDownloadURL();
    return { path, url };
  };

  getStorageURL = async (path) => firebase.storage().ref(path).getDownloadURL();

  addFormWithStockNumberConcat = (collection, form) => {
    form.stock = `SN${form.stock}`;
    // form.stock = `${form.stock}-${form.location}`;
    this.uploadForm(collection, form, form);
  }

  addFormWithCallback = (collection, form) => this.uploadForm(collection, form, form);

  addItemWithCallback = (collection, form) => this.uploadForm(collection, form, form.parameter);

  clearChecks = async (collection, form) => {
    const db = firebase.firestore();
    
    const iterable = [...form[form.iterable]];
    for (let i = 0; i < iterable.length; i++) {
      const item = iterable[i];
      await db.collection(collection).doc(item.checkNumber).update({status:'cleared'});
    }
    return {complete: true};
  }

  assignCheck = async (collection, form) => {
    const iterable = [...form[form.iterable]];
    delete form[form.iterable];
    delete form.iterable;
    form.account = 'inventory';
    form.memo = form.check + " - " + form.memo;
    const checkID = form.check;
    delete form.check;
    for (let i = 0; i < iterable.length; i++) {
      const item = iterable[i];
      console.log({...form, ...item})
      await this.uploadForm(collection, {...form, ...item}, checkID)
    }
    return {complete: true};
  }

  assignCash = async (collection, form) => {
    const iterable = [...form[form.iterable]];
    const cashID = form.cash;
    delete form[form.iterable];
    delete form.iterable;
    delete form.cur_memo
    delete form.cur_amount
    delete form.cash
    let reductionAmount = 0;
    for (let i = 0; i < iterable.length; i++) {
      let item = iterable[i];
      item.account = item.stock === undefined || item.stock === '-FL' ? 'expense' : 'inventory'
      if(item.stock === undefined || item.stock === '-FL') delete item.stock;
      item.memo = "CASH - " + item.memo;
      await this.uploadForm(collection, {...form, ...item,  cashID});
      reductionAmount += item.amount;
      //TODO update current withdrawls amount
    }
    const increment = firebase.firestore.FieldValue.increment(-reductionAmount);
    await firebase.firestore().doc('cash/'+cashID).update({amount: increment});
    return {complete: true};
  }

  uploadRequest = async (collection, form) => {
    // const delay = ms => new Promise(res => setTimeout(res, ms));
    // await delay(3000);
    // return {complete: true};
    if(!collection || !form) return {complete: false};
    const db = firebase.firestore();
    form.date = moment().format('YYYY/MM/DD');
    // var processPaymentRequest = firebase.functions().httpsCallable('processPaymentRequest');

    if(form.payment === 'check'){
      //request check data from firebase functions
      //form.check = await processPaymentRequest({form});

      const {check, pdf} = await RequestManager.post({function: 'processPaymentRequest', variables:{form} });
      form.check = check;
      form.check.pdf = pdf;

      let url = "data:application/pdf;base64,"+form.check.pdf;
      let filename = `Check ${form.bank.lastCheck} - ${form.vendor}.pdf`;
      var file = dataURLtoFile(url, filename);
      var data = window.URL.createObjectURL(file);
      // base64toPDF(form.check.pdf, `Check ${form.bank.lastCheck} - ${form.vendor}.pdf`)
      let a = document.createElement('a');
      a.href = data;
      a.title = filename;
      a.download = filename;
      a.target="_blank";
      a.click();
      // window.open(url, "_blank")
      //increase check number for bank
      await db.doc(`banks/${form.bank.name}-${form.bank.accountNumber}`).update({lastCheck: firebase.firestore.FieldValue.increment(1)});
    }
    else if(form.payment === 'wire'){
      const wire = await RequestManager.post({function: 'processPaymentRequest', variables:{form} });
      console.log('Wire request sent!');
    }

    // await db.collection(collection).doc().set(form);
    return {complete: true};
  }

  generateForm = (name, parameters) => {
    // this.clearForm()
    this.form = forms[name] || {};
    this.form.filterInputs && this.form.filterInputs(this.form);
    this[name] = {};

    const keys = Object.keys(parameters);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      const {inputs} = this.form;
      for (let j = 0; j < inputs.length; j++) {
        const input = inputs[j];
        if(input.id === key) {
          this.form.inputs[j].defaultValue =  !!input.mask ? input.mask(parameters[key]) : parameters[key];
          break;
        }
      }
    }
    return this.form;
  }

  // getUser = async (id) => {
  //   const user = await Firebase.firestore().doc(`people/${id}`).get();
  //   this.user = user.data();
  //   this.user.id = id;
  //   if(this.firstLogin) this.klaviyoTrack();
  // }

  // createCar = async (car) => {
  //   //Create car
  //   const carRef = Firebase.firestore().collection('cars').doc();
  //   car.readableTitle = `${car.year} ${car.make} ${car.model}'`;
  //   car = {...car, owner: user.id, timeCreated: new Date()};
  //   await carRef.set(car);
  //   this.cars = [...this.cars, car];
  // };

  handleError = (e) =>{
    console.log(e);
    this.setMessage(e.message || 'An uknown error occurred.  Please try again');
    this.openError(true);
    this.toggleLoading(true);
    return Promise.resolve(false);
  };

  calculateTax = async (deal, trades = []) => {
    const { cashPrice = 0, docFee = 0 } = deal;
    const tradeSanp = await firebase.firestore().collection(`trades`).where('stock', '==', deal.stock).get();
    const tradeValue = tradeSanp.docs.map(doc => doc.data().trade).reduce( (a,c) => a + c, 0);
    const taxBase = Math.max(0, cashPrice + docFee - tradeValue);
    const salesTax = Math.round(taxBase * 0.06 *100)/100;
    const surtax = Math.round(100 * (taxBase * 0.01 >= 50 ? 50 : taxBase * 0.01)) / 100;
    return [salesTax, surtax]
  };

  calculateProfit = (location) => {
    const { 
      cashPrice = 0,
      docFee = 0,
      conciergeFee = 0,
      shippingCost = 0,
      inventoryCost = 0,
      miscCost = 0,
    } = this[location];

    const profit = cashPrice + docFee + conciergeFee - shippingCost - inventoryCost - miscCost;
    this[location].profit = profit
    this.activeFormSetter['profit']('$'+profit.toLocaleString());
  };

  updatePaidDate = (location, updatedVar) => {
    // console.log(updatedVar, this[location]);
    // console.log(this.activeFormSetter);
    let target_location  = this[location];
    let target_setter = "paidDate";
    const { iterable = false } = target_location;
    const isArray = !!iterable;
    if(isArray){
      let index = 0;
      [updatedVar, index] = updatedVar.split("-");
      target_location = this[location][iterable][index];
      target_setter = target_setter+`-${index}`;
    } 
    // console.log(target_location)

    if(updatedVar !== "isPayable") return;
    
    const { isPayable } = target_location;
    // console.log(isPayable);
    const new_paid_date = !!isPayable ? "" : moment().format("YYYY/MM/DD");

    this.activeFormSetter[target_setter](new_paid_date);
    target_location.paidDate = new_paid_date;
  }

  updateCompleteDate = (location, updatedVar) => {
    if(updatedVar !== "is_complete") return;

    const { is_complete } = this[location];
    const new_date = is_complete ? moment().format("YYYY/MM/DD") : "";

    this.activeFormSetter["end_date"](new_date);
    this[location].end_date = new_date;
  }

  calculateServiceCost = async (location) => {
    let { 
      time = 0,
      mechanic = "",
      revenue = 0,
    } = this[location];
    
    mechanic = constants.mechanics.filter(x => x.name == mechanic).at(0) || {};
    console.log(mechanic)
    let {rate = 0, id = ""} = mechanic;
    if(Object.keys(mechanic).length < 1) rate = 0;

    this[location].rate = Number(rate);
    this.activeFormSetter['rate'](rate);
    this[location].mechanicID = id;
    this.activeFormSetter['mechanicID'](id);
    
    // Add assignDate when mechanic is assigned
    if (id) {
      const assignDate = moment().format('YYYY/MM/DD');
      this[location].assignDate = assignDate;
      this.activeFormSetter['assignDate'](assignDate);
    }
    
    const cost = Number(rate) * Number(time);
    console.log(cost, id)
    this[location].cost = Number(cost);
    this.activeFormSetter['cost'](cost);
  }

  calculatePartProfit = async (location) => {
    let { 
      cost = 0,
      revenue = 0,
    } = this[location];

    if(!StateManager.isAdmin()){
      revenue = Math.round(Number(cost) * 1.35 * 100)/100;
      this[location].revenue = Number(revenue);
      this.activeFormSetter['revenue'](revenue);
      console.log(cost, revenue);
    }


    const profit = Number(revenue) - Number(cost);
    this[location].profit = Number(profit);
    this.activeFormSetter['profit'](profit);
  }

  calculateTotal = async (location) => {
    const { 
      cashPrice = 0,
      docFee = 0,
      conciergeFee = 0,
      titleFee = 0,
      tagFee = 0,
      hasTax,
    } = this[location];
    console.log(this)

    const [salesTax, surtax] = hasTax ? await this.calculateTax(this[location]) : [0, 0];

    const total = Number(cashPrice) + Number(docFee) + Number(conciergeFee) + Number(titleFee) + Number(tagFee) + Number(salesTax) + Number(surtax);
    
    this.activeFormSetter['total'](total);
    this.activeFormSetter['salesTax'](salesTax);
    this.activeFormSetter['surtax'](surtax);

    this[location].total = total;
    this[location].revenue = cashPrice + docFee + conciergeFee + titleFee + tagFee;
    this[location].salesTax = Number(salesTax);
    this[location].surtax = Number(surtax);
    this[location] = {...this[location]}
    console.log(this[location])
  };

  shippingTotal = async (location) => {
    const { price = 0, adjustments = 0 } = this[location];
    const total = Number(price) - Number(adjustments);
    this.activeFormSetter['total']('$'+total.toLocaleString());
    this[location].total = total;
  };

  financeTotal = async (location) => {
    const { conciergeFee = 0, participationFee = 0, adjustments = 0 } = this[location];
    const total = Number(conciergeFee) + Number(participationFee) - Number(adjustments);
    this.activeFormSetter['total']('$'+total.toLocaleString());
    this[location].total = total;
  };

  calculate = (location, key, items, options = {money: true}) => {
    let value = 0
    const keys = Object.keys(items);
    for (const [index, item] of Object.entries(items)) {
      if(item === '+') value += this[location][index] || 0;
      else value -= this[location][index] || 0;
    }

    this[location][key] = value

    if(options.money) value = '$'+value.toLocaleString();
    this.activeFormSetter[key](value);
  }

  formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  };

  // Find the open service order for a car (status !== 'complete'). Returns most recent by date, or null.
  getOpenServiceOrderForCar = async (stockNumber) => {
    if (!stockNumber) return null;
    const snap = await firebase.firestore()
      .collection('orders')
      .where('car', '==', stockNumber)
      .get();
    const open = snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(o => o.status !== 'complete');
    if (open.length === 0) return null;
    open.sort((a, b) => (b.date || '').localeCompare(a.date || ''));
    return open[0];
  };

  // Look up a car by stock number (= Firestore doc id).
  getCarByStock = async (stockNumber) => {
    if (!stockNumber) return null;
    const doc = await firebase.firestore().doc(`cars/${stockNumber}`).get();
    if (!doc.exists) return null;
    return { stock: stockNumber, ...doc.data() };
  };

  // Amount on the car's NTO payable (purchases/{stock}-NTO), or null if none.
  // Ron Check-In compares against this — generateRonChecks uses the same doc.
  getNtoPayableAmount = async (stockNumber) => {
    if (!stockNumber) return null;
    const doc = await firebase.firestore().doc(`purchases/${stockNumber}-NTO`).get();
    if (!doc.exists) return null;
    const amount = Number(doc.data().amount);
    return Number.isFinite(amount) ? amount : null;
  };

  // Lead routing lists on a car: { allowedReps } and/or { excludedReps }, as
  // arrays of user ids. firestore.rules rejects the write for non-admins.
  setCarLeadReps = async (stockNumber, lists) => {
    await firebase.firestore().doc(`cars/${stockNumber}`).set(lists, { merge: true });
  };

  // What a consignor needs on file before Mercury will accept a payout, read
  // for the Pay NTO pre-flight. Returns only a masked account number — the full
  // number never leaves Firestore for the browser.
  getConsignorPayoutInfo = async (stockNumber) => {
    const car = await this.getCarByStock(stockNumber);
    if (!car) return { error: `Car ${stockNumber} not found` };

    const amount = car.updated_nto || car.nto || 0;
    if (!car.consignor) return { error: 'No consignor is set on this car', amount };

    const doc = await firebase.firestore().doc(`customers/${car.consignor}`).get();
    if (!doc.exists) return { error: 'The consignor customer record is missing', amount };
    const cust = doc.data();

    const missing = ['routing_number', 'account_number', 'address1', 'city', 'state', 'zip']
      .filter(field => !cust[field]);

    return {
      customerId: car.consignor,
      name: `${cust.first_name || ''} ${cust.last_name || ''}`.trim(),
      email: cust.email || '',
      last4: String(cust.account_number || '').slice(-4),
      hasRecipient: !!cust.mercury_recipient_id,
      missing,
      amount,
      usedUpdatedNto: !!car.updated_nto,
    };
  };

  // Batch-fetch just the status for many cars by stock number. Algolia car
  // records don't carry status, so callers (e.g. search results) hydrate it
  // from Firestore. Returns a { [stock]: status } map. Chunked into groups of
  // 10 to respect Firestore's documentId() `in` query limit.
  getCarStatuses = async (stockNumbers = []) => {
    const stocks = [...new Set(stockNumbers.filter(Boolean))];
    if (!stocks.length) return {};
    const db = firebase.firestore();
    const chunks = [];
    for (let i = 0; i < stocks.length; i += 10) chunks.push(stocks.slice(i, i + 10));
    const statusMap = {};
    await Promise.all(chunks.map(async (chunk) => {
      const snap = await db
        .collection('cars')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk)
        .get();
      snap.forEach(doc => { statusMap[doc.id] = doc.data().status; });
    }));
    return statusMap;
  };

  // ── AI car chat history (cars/{stock}/chats subcollection). Chats are never
  //    deleted; each chat doc holds the full message array + metadata. ──
  getCarChats = async (stockNumber) => {
    if (!stockNumber) return [];
    const snap = await firebase.firestore()
      .collection(`cars/${stockNumber}/chats`)
      .orderBy('updatedAt', 'desc')
      .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  getCarChat = async (stockNumber, chatId) => {
    if (!stockNumber || !chatId) return null;
    const doc = await firebase.firestore().doc(`cars/${stockNumber}/chats/${chatId}`).get();
    if (!doc.exists) return null;
    return { id: doc.id, ...doc.data() };
  };

  createCarChat = async (stockNumber, title = 'New chat') => {
    if (!stockNumber) return null;
    const ref = firebase.firestore().collection(`cars/${stockNumber}/chats`).doc();
    const now = firebase.firestore.Timestamp.now();
    const data = {
      title,
      messages: [],
      createdBy: StateManager.userName || 'Unknown',
      createdAt: now,
      updatedAt: now,
    };
    await ref.set(data);
    return { id: ref.id, ...data };
  };

  saveCarChat = async (stockNumber, chatId, { messages, title } = {}) => {
    if (!stockNumber || !chatId) return;
    const update = { updatedAt: firebase.firestore.Timestamp.now() };
    if (messages) update.messages = messages;
    if (title) update.title = title;
    await firebase.firestore().doc(`cars/${stockNumber}/chats/${chatId}`).set(update, { merge: true });
  };

  // ── AI service-order chat history (orders/{id}/chats subcollection). Same
  //    shape as the car chat above; read-only chat, so there is no apply step. ──
  getServiceOrderChats = async (orderId) => {
    if (!orderId) return [];
    const snap = await firebase.firestore()
      .collection(`orders/${orderId}/chats`)
      .orderBy('updatedAt', 'desc')
      .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  createServiceOrderChat = async (orderId, title = 'New chat') => {
    if (!orderId) return null;
    const ref = firebase.firestore().collection(`orders/${orderId}/chats`).doc();
    const now = firebase.firestore.Timestamp.now();
    const data = {
      title,
      messages: [],
      createdBy: StateManager.userName || 'Unknown',
      createdAt: now,
      updatedAt: now,
    };
    await ref.set(data);
    return { id: ref.id, ...data };
  };

  saveServiceOrderChat = async (orderId, chatId, { messages, title } = {}) => {
    if (!orderId || !chatId) return;
    const update = { updatedAt: firebase.firestore.Timestamp.now() };
    if (messages) update.messages = messages;
    if (title) update.title = title;
    await firebase.firestore().doc(`orders/${orderId}/chats/${chatId}`).set(update, { merge: true });
  };

  // Apply a car-record edit proposed by the AI chat (after the staff member
  // clicks Apply). Writes the proposed fields plus an appended audit note in a
  // single update.
  applyCarChatUpdate = async (stockNumber, updates, auditNote, allNotes) => {
    if (!stockNumber || !updates || Object.keys(updates).length === 0) return;
    const payload = { ...updates };
    // VINs are always stored uppercase (the manual inputs enforce this); the AI
    // chat can propose any case, so normalize here and keep the search suffixes
    // in sync.
    if (typeof payload.vin === 'string') {
      payload.vin = payload.vin.trim().toUpperCase();
      if (payload.vin.length >= 3) {
        payload.vin_suffixes = [payload.vin.slice(-6), payload.vin.slice(-5), payload.vin.slice(-4)];
      }
    }
    if (auditNote) payload.notes = allNotes;
    await firebase.firestore().doc(`cars/${stockNumber}`).update(payload);
  };

  // Car Demand report data. The join + aggregation runs server-side in the
  // getCarDemandReport Cloud Function (the full per-car history is ~150MB —
  // far too much to assemble in the browser). Returns { rows, trend, range }.
  // Pass startDate/endDate (YYYY-MM-DD) to restrict metrics + trend to a range.
  getCarDemandReport = async ({ startDate = null, endDate = null, listedOnly = false, soldInRange = false, stocks = null } = {}) => {
    const variables = {};
    if (startDate && endDate) { variables.startDate = startDate; variables.endDate = endDate; }
    if (listedOnly) variables.listedOnly = true;
    if (soldInRange) variables.soldInRange = true;
    if (stocks && stocks.length) variables.stocks = stocks.join(',');
    const result = await RequestManager.get({ function: 'getCarDemandReport', variables });
    if (!result || result.success === false) {
      throw new Error('Failed to load car demand report');
    }
    return {
      rows: result.rows || [],
      trend: result.trend || [],
      histories: result.histories || null,
      range: result.range || null,
    };
  };

  // Active inventory distribution. The per-car purchases roll-up runs in the
  // inventoryDistribution Cloud Function (one purchases query per car — too many
  // round-trips for the browser). Returns raw rows; the report buckets them
  // client-side. Pass asOf ("MM/DD/YYYY" | "YYYY-MM-DD") for a point-in-time snapshot.
  getInventoryDistribution = async ({ asOf = null } = {}) => {
    const variables = {};
    if (asOf) variables.asOf = asOf;
    const result = await RequestManager.get({ function: 'inventoryDistribution', variables });
    if (!result || result.success === false) {
      throw new Error('Failed to load inventory distribution');
    }
    return { rows: result.rows || [], asOf: result.asOf || null, count: result.count || 0 };
  };

  // Resolve a userID to a display name from the `users` collection ("First Last").
  // Cached in-memory per id so repeated lookups (e.g. re-opening modals) don't refetch.
  // Returns null if the user doc is missing or has no name. `constants.userNames` is a
  // hardcoded cache of this same collection; this covers ids that aren't in that map.
  _userNameCache = {};
  getUserName = async (id) => {
    if (!id) return null;
    if (Object.prototype.hasOwnProperty.call(this._userNameCache, id)) {
      return this._userNameCache[id];
    }
    try {
      const doc = await firebase.firestore().collection('users').doc(id).get();
      const data = doc.exists ? doc.data() : null;
      const name = data
        ? `${data.firstName || ''} ${data.lastName || ''}`.trim() || null
        : null;
      this._userNameCache[id] = name;
      return name;
    } catch (err) {
      console.warn('getUserName failed:', err);
      return null;
    }
  };

  // Active mechanics from the users collection. Used by the mechanic clock-in page.
  getActiveMechanics = async () => {
    const snap = await firebase.firestore()
      .collection('users')
      .where('userType', '==', 'mechanic')
      .get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(u => !u.archived)
      .map(u => ({
        id: u.id,
        name: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
        rate: Number(u.rate || 0),
      }))
      .filter(u => u.name)
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  // Mechanic roster — the source of truth for mechanic names/rates across the app
  // (service-line cost math, payroll, dropdowns, id→name lookups). Stored in the
  // `mechanics` collection, doc id == mechanic id. Hydrated into constants.mechanics
  // at app boot (App.js) and managed on the User Management page's Mechanics tab.
  getMechanics = async () => {
    const snap = await firebase.firestore().collection('mechanics').get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  // Create or update a mechanic. The rate is written only on create, as the
  // baseline of the rate schedule. Rate changes on an existing mechanic go
  // through the setMechanicRate function, which applies an effective date,
  // re-prices past work, logs history, and mirrors the rate onto users/{id}.
  saveMechanic = async (id, data) => {
    const db = firebase.firestore();
    const clean = {
      name: (data.name || '').trim(),
      rate: Number(data.rate || 0),
      cat: data.cat || 'INVR',
      is_active: data.is_active !== false,
      // Opt-in: the self-serve Clock In button on the Mechanic Orders page only
      // shows for mechanics an admin has explicitly enabled here.
      clock_in_enabled: data.clock_in_enabled === true,
      // Opt-in: lets this mechanic edit (name/notes/tag) and delete NON-completed
      // service lines. Hours still route through the proposed-hours request flow.
      can_edit_lines: data.can_edit_lines === true,
      // Lunch auto clock-out time, 'HH:mm' 24h ET. Blank = not enrolled in the
      // lunch policy. Set per mechanic so the shop is staggered rather than
      // everyone dropping off the clock at the same minute. The policy only fires
      // on/after the go-live date in settings/mechanic_lunch.
      // Stored zero-padded so plain 'HH:mm' string compares (cron-window checks,
      // sorting) are valid.
      lunch_clock_out: (() => {
        const parts = /^(\d{1,2}):(\d{2})$/.exec(String(data.lunch_clock_out || '').trim());
        if (!parts) return '';
        const hours = Number(parts[1]);
        const minutes = Number(parts[2]);
        if (hours > 23 || minutes > 59) return '';
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      })(),
    };
    const prevSnap = await db.doc(`mechanics/${id}`).get();
    const isNew = !prevSnap.exists;
    if (isNew) {
      // '0000/00/00' = in effect for every day before the first dated change.
      clean.rateSchedule = [{ from: '0000/00/00', rate: clean.rate }];
    } else {
      delete clean.rate;
    }

    await db.doc(`mechanics/${id}`).set(clean, { merge: true });

    if (isNew) {
      await db.collection(`mechanics/${id}/rateHistory`).add({
        rate: clean.rate,
        previousRate: null,
        changedAt: firebase.firestore.Timestamp.now(),
        changedBy: StateManager.userID || '',
        changedByName: StateManager.userName || '',
      });
    }

    // Mirror the name too, for mechanics only. The backend resolves a clock-in
    // mechanic from users/{id} firstName+lastName FIRST and only falls back to
    // mechanics/{id}.name (resolveMechanic in service/helpers.js), so a roster
    // rename that skipped the users doc would keep stamping the old name onto
    // new timeLogs. createStaffLogin derives the same split from the roster, so
    // the two records are meant to match.
    const userDoc = await db.doc(`users/${id}`).get();
    if (userDoc.exists) {
      const update = isNew ? { rate: clean.rate } : {};
      if (userDoc.data().userType === 'mechanic' && clean.name) {
        const parts = clean.name.split(/\s+/);
        update.firstName = parts[0];
        update.lastName = parts.slice(1).join(' ');
      }
      if (Object.keys(update).length) await db.doc(`users/${id}`).update(update);
    }
  };

  // Rate-change history for a mechanic, newest first. Each entry:
  // { rate, previousRate, changedAt (Timestamp), changedBy, changedByName }, plus
  // effectiveDate ('YYYY/MM/DD') and repriced counts for setMechanicRate changes.
  getRateHistory = async (id) => {
    const snap = await firebase.firestore()
      .collection(`mechanics/${id}/rateHistory`)
      .orderBy('changedAt', 'desc')
      .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  // One-time population of the `mechanics` collection from the hardcoded defaults.
  // Idempotent: only writes ids that don't already exist. Returns the count seeded.
  seedMechanicsFromDefaults = async (defaults = []) => {
    const existing = await firebase.firestore().collection('mechanics').get();
    const have = new Set(existing.docs.map(d => d.id));
    const toSeed = defaults.filter(m => m.id && m.id !== 'test' && !have.has(m.id));
    if (!toSeed.length) return 0;
    const db = firebase.firestore();
    const now = firebase.firestore.Timestamp.now();
    const batch = db.batch();
    toSeed.forEach(m => {
      const rate = Number(m.rate || 0);
      batch.set(db.doc(`mechanics/${m.id}`), {
        name: m.name,
        rate,
        rateSchedule: [{ from: '0000/00/00', rate }],
        cat: m.cat || 'INVR',
        is_active: m.is_active !== false,
      });
      // Baseline rate-history entry so the history starts from the imported rate.
      batch.set(db.collection(`mechanics/${m.id}/rateHistory`).doc(), {
        rate,
        previousRate: null,
        changedAt: now,
        changedBy: 'seed',
        changedByName: 'Initial import',
      });
    });
    await batch.commit();
    return toSeed.length;
  };

  // ── Lunch auto clock-out policy ──────────────────────────────────────────
  // Shop-wide switch + go-live date for the per-mechanic lunch clock-out. The
  // per-mechanic TIMES live on each mechanics doc (`lunch_clock_out`); this doc
  // only says whether the policy is on and from what date, so the mechanics can
  // be told before it starts affecting their hours.

  // Live read straight from Firestore. An absent doc yields {} — the backend
  // supplies the defaults (off, no go-live date), so empty is a valid state.
  // Default permission sets per role, editable on User Management's Roles tab.
  // Lives in its own `rolePresets` collection rather than under `settings` because
  // `settings` is writable by any signed-in user, and these are the defaults that
  // decide what a role can reach — the Firestore rule on this collection restricts
  // writes to accounts holding 'user-management'.
  subscribeRolePresets = (callback) =>
    firebase.firestore().collection('rolePresets').doc('current')
      .onSnapshot(
        doc => callback(doc.exists ? doc.data() : {}),
        () => callback({}),
      );

  saveRolePresets = async (presets) => {
    await firebase.firestore().collection('rolePresets').doc('current').set({
      ...presets,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedBy: StateManager.userID || null,
    }, { merge: true });
  };

  // Part auto-approve switch. A missing doc or field means auto-approve is on.
  // The backend processPart function reads the same doc.
  subscribePartsSettings = (callback) =>
    firebase.firestore().collection('settings').doc('parts')
      .onSnapshot(
        doc => callback(doc.exists ? doc.data() : {}),
        () => callback({}),
      );

  getPartsSettings = async () => {
    const doc = await firebase.firestore().collection('settings').doc('parts').get();
    return doc.exists ? doc.data() : {};
  };

  savePartsSettings = (settings) =>
    firebase.firestore().collection('settings').doc('parts').set({
      ...settings,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedBy: StateManager.userID || null,
    }, { merge: true });

  // Move `quantity` of a parts-inventory item onto a service order as a
  // 'complete' part (it is already in hand). The inventory doc is deleted when
  // its stock reaches 0. `fromInventory` keeps a snapshot so
  // returnPartToInventory can undo the move. syncPartPurchase books the cost
  // to the SO. Returns the new part id.
  movePartToServiceOrder = async (inventoryId, orderId, quantity) => {
    const db = firebase.firestore();
    const invRef = db.collection('parts-inventory').doc(inventoryId);
    const partRef = db.collection('parts').doc();
    const qty = parseInt(quantity, 10);
    if (!orderId) throw new Error('Pick a service order.');
    if (!(qty > 0)) throw new Error('Quantity must be at least 1.');

    await db.runTransaction(async (tx) => {
      const invSnap = await tx.get(invRef);
      if (!invSnap.exists) throw new Error('This part is no longer in inventory.');
      const inv = invSnap.data();
      const onHand = Number(inv.quantity) || 0;
      if (qty > onHand) throw new Error(`Only ${onHand} on hand.`);

      const unitPrice = Number(inv.unitPrice ?? inv.cost) || 0;
      const now = moment().format('YYYY/MM/DD');
      tx.set(partRef, {
        name: inv.name || '',
        vendor: 'Parts Inventory',
        partNumber: '',
        link: '',
        notes: [inv.location && `Inventory location: ${inv.location}`, inv.notes].filter(Boolean).join('\n'),
        quantity: qty,
        cost: unitPrice,
        date: now,
        status: 'complete',
        status_time: now,
        order: orderId,
        fromInventory: {
          id: inventoryId,
          name: inv.name || '',
          location: inv.location || '',
          unitPrice,
          notes: inv.notes || '',
          thumbnail: inv.thumbnail || '',
        },
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
      });

      if (qty === onHand) tx.delete(invRef);
      else tx.update(invRef, { quantity: onHand - qty });
    });
    return partRef.id;
  };

  // Undo movePartToServiceOrder: put the part's quantity back in inventory
  // (recreating the inventory doc if it was deleted) and delete the SO part.
  // syncPartPurchase then deletes the linked purchase.
  returnPartToInventory = async (partId) => {
    const db = firebase.firestore();
    const partRef = db.collection('parts').doc(partId);

    await db.runTransaction(async (tx) => {
      const partSnap = await tx.get(partRef);
      if (!partSnap.exists) throw new Error('This part is no longer on the service order.');
      const part = partSnap.data();
      const src = part.fromInventory;
      if (!src || !src.id) throw new Error('This part did not come from inventory.');

      const invRef = db.collection('parts-inventory').doc(src.id);
      const invSnap = await tx.get(invRef);
      const qty = parseInt(part.quantity, 10) || 1;

      if (invSnap.exists) {
        tx.update(invRef, { quantity: (Number(invSnap.data().quantity) || 0) + qty });
      } else {
        tx.set(invRef, {
          name: src.name || '',
          location: src.location || '',
          quantity: qty,
          unitPrice: Number(src.unitPrice) || 0,
          notes: src.notes || '',
          thumbnail: src.thumbnail || '',
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      tx.delete(partRef);
    });
  };

  subscribeMechanicLunchSettings = (callback) =>
    firebase.firestore().collection('settings').doc('mechanic_lunch')
      .onSnapshot(
        doc => callback(doc.exists ? doc.data() : {}),
        () => callback({}),
      );

  // Writes go through the backend so the go-live date the unattended cron reads
  // is validated in exactly one place.
  saveMechanicLunchSettings = (settings) =>
    RequestManager.post({
      function: 'saveMechanicLunchSettings',
      variables: { settings, userId: StateManager.userID },
    });

  // Dry run: who the policy would clock out on this tick, writing nothing.
  previewMechanicLunchClockOut = () =>
    RequestManager.post({ function: 'previewLunchAutoClockOut', variables: {} });

  // Sales reps from the users collection — userType == 'sales' OR type == 'sales'.
  // Populates the manual lead-assignment dropdowns (constants.sales). Auto-assign
  // rotation membership is controlled separately on the Lead Management page
  // (pauseLeads), so paused reps still appear here for manual assignment.
  getSalesUsers = async () => {
    const [userTypeSnap, typeSnap] = await Promise.all([
      firebase.firestore().collection('users').where('userType', '==', 'sales').get(),
      firebase.firestore().collection('users').where('type', '==', 'sales').get(),
    ]);
    const byId = new Map(
      [...userTypeSnap.docs, ...typeSnap.docs].map(d => [d.id, { id: d.id, ...d.data() }])
    );
    return Array.from(byId.values())
      .filter(u => !u.archived)
      .map(u => ({ id: u.id, name: `${u.firstName || ''} ${u.lastName || ''}`.trim() }))
      .filter(u => u.name)
      .sort((a, b) => (a.name.split(' ').at(-1) >= b.name.split(' ').at(-1) ? 1 : -1));
  };

  // Credit-app lenders (the banks customer credit apps are sent to). Stored in
  // the `lenders` collection, keyed by lender id (workers, jjbest, …). Distinct
  // from the `banks` collection, which holds Skyway's own payment accounts.
  getLenders = async () => {
    const snap = await firebase.firestore().collection('lenders').get();
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  };

  saveLender = async (id, data) => {
    await firebase.firestore().doc(`lenders/${id}`).set(data, { merge: true });
  };

  // History of credit-app sends to banks, for review/audit. Filter by credit app,
  // customer, or stock (or pass nothing to fetch all). Sorted newest-first
  // client-side to avoid a composite index.
  getCreditAppSends = async ({ creditAppId, customerId, stockNumber } = {}) => {
    let query = firebase.firestore().collection('credit-app-sends');
    if (creditAppId) query = query.where('creditAppId', '==', creditAppId);
    else if (customerId) query = query.where('customerId', '==', customerId);
    else if (stockNumber) query = query.where('stockNumber', '==', stockNumber);
    const snap = await query.get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.sentAt?.seconds || 0) - (a.sentAt?.seconds || 0));
  };

  // History of bank stipulation sends, so the Finance tab can show what went out
  // and when, and a resend can start from what was sent last. Sorted newest-first
  // client-side to avoid a composite index.
  getStipSends = async ({ stockNumber } = {}) => {
    let query = firebase.firestore().collection('stip-sends');
    if (stockNumber) query = query.where('stockNumber', '==', String(stockNumber));
    const snap = await query.get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.sentAt?.seconds || 0) - (a.sentAt?.seconds || 0));
  };

  // Realtime send history for one service order: every outbound estimate and
  // invoice, email-only and e-signature alike, each carrying a snapshot of the
  // lines and totals that were on it.
  //
  // Written server-side only — the app never writes here, so this is read-only.
  // Sorted newest-first client-side to avoid a composite index. A server
  // timestamp is unresolved in the first local snapshot after a write, so an
  // unset sentAt sorts first: it is the newest send.
  subscribeServiceDocumentSends = (stock, callback) => {
    if (!stock) { callback([]); return () => {}; }
    return firebase.firestore()
      .collection(`orders/${String(stock)}/documentSends`)
      .onSnapshot(snap => {
        callback(snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (b.sentAt?.seconds ?? Number.MAX_SAFE_INTEGER) - (a.sentAt?.seconds ?? Number.MAX_SAFE_INTEGER)));
      }, () => callback([]));
  };

  // Credit apps linked to a customer via the canonical `credit-apps.customer` field.
  getCreditAppsForCustomer = async (customerId) => {
    if (!customerId) return [];
    const snap = await firebase.firestore().collection('credit-apps').where('customer', '==', customerId).get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.time || '').localeCompare(a.time || ''));
  };

  // Unique stock numbers of every car a customer consigned, bought, or co-bought.
  // Includes service (-SR) stocks; callers filter. Used by the car source
  // suggestion (Ads Growth Plan A5) to spot repeat consignors.
  getCustomerCarStocks = async (customerId) => {
    if (!customerId) return [];
    const db = firebase.firestore();
    const snaps = await Promise.all([
      db.collection('cars').where('consignor', '==', customerId).get(),
      db.collection('deals').where('buyer', '==', customerId).get(),
      db.collection('deals').where('cobuyer', '==', customerId).get(),
    ]);
    const stocks = new Set();
    snaps.forEach(snap => snap.docs.forEach(d => stocks.add((d.data() || {}).stock || d.id)));
    return [...stocks];
  };

  linkCreditAppToCustomer = async (creditAppId, customerId) => {
    await firebase.firestore().doc(`credit-apps/${creditAppId}`).set({ customer: customerId }, { merge: true });
  };

  unlinkCreditAppFromCustomer = async (creditAppId) => {
    await firebase.firestore().doc(`credit-apps/${creditAppId}`).update({ customer: firebase.firestore.FieldValue.delete() });
  };

  // Point a credit app at a car. The car modal links on the fly when a deal's
  // buyer is sent to lenders, so nobody has to link the app by hand first.
  linkCreditAppToCar = async (creditAppId, { stock, car_title = '', car_thumbnail = '' } = {}) => {
    if (!creditAppId || !stock) return;
    await firebase.firestore().doc(`credit-apps/${creditAppId}`).set(
      { stock: String(stock).toUpperCase(), car_title, car_thumbnail },
      { merge: true },
    );
  };

  // Co-applicant (co-buyer) linking between two credit apps. Stored bidirectionally
  // as `co_applicant` so either app can be sent with the other as co-buyer.
  linkCoApplicant = async (creditAppId, otherAppId) => {
    const db = firebase.firestore();
    await Promise.all([
      db.doc(`credit-apps/${creditAppId}`).set({ co_applicant: otherAppId }, { merge: true }),
      db.doc(`credit-apps/${otherAppId}`).set({ co_applicant: creditAppId }, { merge: true }),
    ]);
  };

  unlinkCoApplicant = async (creditAppId) => {
    const db = firebase.firestore();
    const snap = await db.doc(`credit-apps/${creditAppId}`).get();
    const otherId = snap.exists ? snap.data().co_applicant : null;
    const ops = [db.doc(`credit-apps/${creditAppId}`).update({ co_applicant: firebase.firestore.FieldValue.delete() })];
    if (otherId) ops.push(db.doc(`credit-apps/${otherId}`).update({ co_applicant: firebase.firestore.FieldValue.delete() }));
    await Promise.all(ops);
  };

  // Clock-in / clock-out wrappers around the atomic backend functions.
  clockIn = async (mechanicId, stockNumber) => {
    return await RequestManager.post({
      function: 'clockInMechanic',
      variables: { mechanicId, stockNumber },
    });
  };

  clockOut = async (mechanicId) => {
    return await RequestManager.post({
      function: 'clockOutMechanic',
      variables: { mechanicId },
    });
  };

  getActiveClockSession = async (mechanicId) => {
    return await RequestManager.post({
      function: 'getActiveClockSession',
      variables: { mechanicId },
    });
  };

  syncSOAllocation = async (serviceOrderId) => {
    return await RequestManager.post({
      function: 'syncSOAllocation',
      variables: { serviceOrderId },
    });
  };

  cleanServiceNote = async (timeLogId, transcript) => {
    return await RequestManager.post({
      function: 'cleanServiceNote',
      variables: { timeLogId, transcript },
    });
  };

  // A mechanic opens an SO for a car, or joins the car's open SO.
  mechanicOpenServiceOrder = async (mechanicId, stockNumber, description) => {
    return await RequestManager.post({
      function: 'mechanicOpenServiceOrder',
      variables: { mechanicId, stockNumber, description },
    });
  };

  // Pending service-line suggestions made from mechanics' clock-out notes.
  subscribeServiceSuggestions = (orderId, callback) =>
    firebase.firestore()
      .collection('serviceSuggestions')
      .where('order', '==', orderId)
      .where('status', '==', 'pending')
      .onSnapshot(
        snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
        err => { console.error('serviceSuggestions listener failed:', err); callback([]); }
      );

  resolveServiceSuggestion = async (suggestionId, action, name) => {
    return await RequestManager.post({
      function: 'resolveServiceSuggestion',
      variables: { suggestionId, action, name, resolvedBy: StateManager.userName || null },
    });
  };

  // ── Mechanic pay-period reads ──────────────────────────────────────────
  // Completed services whose completion date falls in [startYMD, endYMD].
  // `status_time` is written zero-padded 'YYYY/MM/DD' everywhere, so a string
  // range query orders correctly.
  getPeriodCompletedServices = async (startYMD, endYMD) => {
    const snap = await firebase.firestore().collection('services')
      .where('status', '==', constants.service_statuses.at(-1))
      .where('status_time', '>=', startYMD)
      .where('status_time', '<=', endYMD)
      .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  // timeLogs that STARTED within the period (lower bound widened one day so a
  // session begun just before the period boundary is caught). The caller clips
  // / pro-rates each session to the exact window client-side.
  getPeriodTimeLogs = async (startMs, endMs, mechanicId = null) => {
    let query = firebase.firestore().collection('timeLogs')
      .where('startTime', '>=', firebase.firestore.Timestamp.fromMillis(startMs - 86400000))
      .where('startTime', '<=', firebase.firestore.Timestamp.fromMillis(endMs));
    if (mechanicId) query = query.where('mechanicId', '==', mechanicId);
    const snap = await query.get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  // SO id → { title: "Year Make Model", photo } for a list of service orders.
  // Each id resolves through its order's car; an id with no order doc is tried
  // as a car stock # directly. Batches 10 ids per `in` query.
  getServiceOrderCars = async (soIds) => {
    const db = firebase.firestore();
    const byIds = async (collection, ids) => {
      const out = {};
      for (let i = 0; i < ids.length; i += 10) {
        const snap = await db.collection(collection)
          .where(firebase.firestore.FieldPath.documentId(), 'in', ids.slice(i, i + 10)).get();
        snap.docs.forEach(d => { out[d.id] = d.data() || {}; });
      }
      return out;
    };
    const ids = [...new Set((soIds || []).filter(Boolean).map(String))];
    const orders = await byIds('orders', ids);
    // Older orders stored the car as an object rather than its stock #.
    const carOf = (so) => {
      const c = orders[so] ? orders[so].car : so;
      return String((c && typeof c === 'object' ? c.id || c.stock : c) || '');
    };
    const cars = await byIds('cars', [...new Set(ids.map(carOf).filter(Boolean))]);
    const first = (v) => (Array.isArray(v) ? v.find(Boolean) : v) || '';
    const result = {};
    ids.forEach(so => {
      const c = cars[carOf(so)];
      if (!c) return;
      result[so] = {
        title: `${c.year || ''} ${c.make || ''} ${c.model || ''}`.trim(),
        photo: c.thumbnail || first(c.ext_images) || '',
      };
    });
    return result;
  };

  // ── Service payment report ─────────────────────────────────────────────
  // Everything the Service Pipeline payment printout needs for one service
  // order, in a single round trip: the vehicle and customer docs plus the four
  // collections the accounting math reads. timeLogs come along because clocked
  // labor is part of cost — without it the profit here wouldn't match the
  // figure on the service order's own Accounting tab.
  getServiceOrderReportData = async (order = {}) => {
    const db = firebase.firestore();
    const id = order.id;
    const list = (snap) => snap.docs.map(d => ({ id: d.id, ...d.data() }));
    // Older orders stored car/customer as objects rather than ids.
    const idOf = (v) => (typeof v === 'string' ? v : (v && v.id) || '');
    const carId = idOf(order.car);
    const customerId = idOf(order.customerID || order.customer);

    const [services, parts, deposits, purchases, timeLogs, car, customer] = await Promise.all([
      db.collection('services').where('order', '==', id).get().then(list),
      db.collection('parts').where('order', '==', id).get().then(list),
      // Service orders and cars share the deposits collection — the `service`
      // type is the SO's money, everything else belongs to the vehicle sale.
      db.collection('deposits').where('stock', '==', id).get().then(s => list(s).filter(x => x.type === 'service')),
      db.collection('purchases').where('stock', '==', id).get().then(list),
      db.collection('timeLogs').where('serviceOrderId', '==', id).get().then(list),
      // Most orders store the car's stock number, which is also the doc id —
      // but not universally, so fall back to a stock lookup before giving up.
      carId
        ? db.doc('cars/' + carId).get().then(async (d) => {
            if (d.exists) return { stock: d.id, ...d.data() };
            const q = await db.collection('cars').where('stock', '==', carId).limit(1).get();
            return q.empty ? {} : { stock: carId, ...q.docs[0].data() };
          })
        : Promise.resolve({}),
      customerId
        ? db.doc('customers/' + customerId).get().then(d => (d.exists ? { id: d.id, ...d.data() } : {}))
        : Promise.resolve({}),
    ]);

    return { ...order, services, parts, deposits, expenses: purchases, timeLogs, carData: car, customerData: customer };
  };

  // Merge one or more duplicate customer documents into a primary customer.
  // - Re-points references in deals (buyer, cobuyer), cars (buyer, cobuyer, consignor),
  //   orders (customer), leads (customer), and credit-apps (customer) to primaryId
  // - Fills in fields on primary that are blank but populated on a duplicate (first non-blank wins)
  // - Deletes the duplicate customer docs from Firestore and Algolia
  mergeCustomers = async (primaryId, duplicateIds = []) => {
    if (!primaryId || !Array.isArray(duplicateIds) || duplicateIds.length === 0) {
      throw new Error('Primary customer ID and at least one duplicate ID are required.');
    }
    if (duplicateIds.includes(primaryId)) {
      throw new Error('Primary customer cannot also be a duplicate.');
    }

    const db = firebase.firestore();

    // 1. Load primary + all duplicates
    const primarySnap = await db.collection('customers').doc(primaryId).get();
    if (!primarySnap.exists) throw new Error('Primary customer not found.');
    const primary = primarySnap.data() || {};

    const duplicateSnaps = await Promise.all(
      duplicateIds.map(id => db.collection('customers').doc(id).get())
    );
    const duplicates = duplicateSnaps
      .filter(snap => snap.exists)
      .map(snap => ({ id: snap.id, ...snap.data() }));

    if (duplicates.length === 0) throw new Error('No duplicate customers found.');

    // 2. Build merged primary field set (primary keeps its values; blanks filled from duplicates in order)
    const merged = { ...primary };
    const isBlank = (v) => v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
    duplicates.forEach(dup => {
      Object.entries(dup).forEach(([key, value]) => {
        if (key === 'id') return;
        if (isBlank(merged[key]) && !isBlank(value)) merged[key] = value;
      });
    });

    // 3. Find all referencing docs and update them to point to primaryId
    const refUpdates = [];

    for (const dupId of duplicateIds) {
      const [buyerDeals, cobuyerDeals, buyerCars, cobuyerCars, consignorCars, customerOrders, leadEntries, creditApps] = await Promise.all([
        db.collection('deals').where('buyer', '==', dupId).get(),
        db.collection('deals').where('cobuyer', '==', dupId).get(),
        // `cars.buyer`/`cars.cobuyer` are denormalized copies of the deal fields
        // above (see CarModal.js) — they must be kept in sync or the car doc
        // goes stale and any code reading it directly (e.g. Sales.js display)
        // still shows the deleted duplicate.
        db.collection('cars').where('buyer', '==', dupId).get(),
        db.collection('cars').where('cobuyer', '==', dupId).get(),
        db.collection('cars').where('consignor', '==', dupId).get(),
        db.collection('orders').where('customer', '==', dupId).get(),
        db.collection('leads').where('customer', '==', dupId).get(),
        db.collection('credit-apps').where('customer', '==', dupId).get(),
      ]);

      buyerDeals.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { buyer: primaryId } }));
      cobuyerDeals.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { cobuyer: primaryId } }));
      buyerCars.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { buyer: primaryId } }));
      cobuyerCars.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { cobuyer: primaryId } }));
      consignorCars.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { consignor: primaryId } }));
      customerOrders.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { customer: primaryId } }));
      leadEntries.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { customer: primaryId } }));
      creditApps.docs.forEach(d => refUpdates.push({ ref: d.ref, update: { customer: primaryId } }));
    }

    // 4. Apply all writes in batches (Firestore batch limit = 500)
    const allWrites = [
      { ref: primarySnap.ref, update: merged, op: 'set' },
      ...refUpdates.map(u => ({ ...u, op: 'set' })),
      ...duplicates.map(d => ({ ref: db.collection('customers').doc(d.id), op: 'delete' })),
    ];

    for (let i = 0; i < allWrites.length; i += 450) {
      const batch = db.batch();
      const chunk = allWrites.slice(i, i + 450);
      chunk.forEach(w => {
        if (w.op === 'delete') batch.delete(w.ref);
        else batch.set(w.ref, w.update, { merge: true });
      });
      await batch.commit();
    }

    return {
      primaryId,
      mergedDuplicates: duplicates.map(d => d.id),
      referencesUpdated: refUpdates.length,
    };
  };

  // Manual shipping labels created from the main-menu tool are recorded in the
  // `shippingLabels` collection (car/title labels live on the car instead).
  // Returns most-recent-first.
  getShippingLabelHistory = async (max = 50) => {
    const snap = await firebase.firestore()
      .collection('shippingLabels')
      .orderBy('createdAt', 'desc')
      .limit(max)
      .get();
    return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  };

  // ── Shipping-OUT status (derived at read time) ─────────────────────────────
  // The car's shipping-out status is NOT stored on the deal. It is derived from
  // the drop-off load the car sits on, so it is always current with the load's
  // own lifecycle (pending → posted → in_progress → completed). A car may appear on many
  // loads (pickups, lot moves, shipping-in) but should only ever be a `dropoff`
  // once — that single drop-off is the customer delivery this status reflects.

  // Cached index of every car that sits on a non-cancelled load:
  //   dropoffs: stock# -> { loadId, load } for the most-recent car_delivery drop-off
  //   pickups:  set of stock#s already scheduled as a car_pickup (shipping in)
  //   history:  stock# -> [{ loadId, load, stop }] every load the car ever sat on
  // One read of shipping-loads per session; call invalidateShippingLoads()
  // after a load is created/edited.
  //
  // `history` deliberately INCLUDES cancelled loads — the Transport tab shows
  // them so a car that was pulled off a load still reads as having been on one.
  // `dropoffs`/`pickups` keep excluding cancelled loads, because those two drive
  // "what still needs shipping" and a cancelled load schedules nothing.
  _stopIndexPromise = null;

  _loadRecency = (load) => {
    const d = (load && (load.created_at || load.departure_date || load.completed_at)) || null;
    return d ? new Date(d).getTime() : 0;
  };

  loadStopIndex = (force = false) => {
    if (force) this._stopIndexPromise = null;
    if (!this._stopIndexPromise) {
      this._stopIndexPromise = (async () => {
        const snap = await firebase.firestore().collection('shipping-loads').get();
        const dropoffs = new Map();
        const pickups = new Set();
        const history = new Map();
        snap.docs.forEach(doc => {
          const load = { id: doc.id, ...doc.data() };

          // History first, so cancelled loads land in it. Only Skyway cars have
          // a stock number — `outside_stop` entries are third-party vehicles
          // with a generated id and no car doc to hang history off.
          (load.cars || []).forEach(c => {
            if (!c || !c.id) return;
            if (c.type !== 'car_delivery' && c.type !== 'car_pickup') return;
            if (!history.has(c.id)) history.set(c.id, []);
            history.get(c.id).push({ loadId: doc.id, load, stop: c });
          });

          if (load.status === 'cancelled') return;
          (load.cars || []).forEach(c => {
            if (!c || !c.id) return;
            if (c.type === 'car_delivery' && c.stopType === 'dropoff') {
              const existing = dropoffs.get(c.id);
              if (!existing || this._loadRecency(load) >= this._loadRecency(existing.load)) {
                dropoffs.set(c.id, { loadId: doc.id, load });
              }
            }
            if (c.type === 'car_pickup') pickups.add(c.id);
          });
        });
        history.forEach(entries => entries.sort((a, b) => this._loadRecency(b.load) - this._loadRecency(a.load)));
        return { dropoffs, pickups, history };
      })().catch(err => {
        // Don't cache a failed read — let the next caller retry.
        this._stopIndexPromise = null;
        throw err;
      });
    }
    return this._stopIndexPromise;
  };

  loadDropoffIndex = async (force = false) => (await this.loadStopIndex(force)).dropoffs;

  invalidateShippingLoads = () => { this._stopIndexPromise = null; };

  // Create a shipping load from a set of stops and return its data. A load
  // needs at least one stop — an empty one only clutters the dashboard — so the
  // backend rejects it, and this rejects it before the round trip.
  //
  // The backend owns creation: it allocates the load number from a counter in a
  // transaction, routes the stops, and marks the delivered deals complete in
  // one call, so no load is written without its route. Writing the document
  // here would re-derive the number by sorting ids, and ids are strings, so
  // '999' sorts above '1429' and the new load lands on top of an existing one.
  createShippingLoad = async (stops, overrides = {}) => {
    const realStops = Array.isArray(stops) ? stops.filter(stop => !!stop) : [];
    if (!realStops.length) {
      throw new Error('stops is required and must contain at least one stop');
    }

    const { optimizeWaypoints = true, ...loadFields } = overrides;
    const response = await RequestManager.post({
      function: 'createShippingLoad',
      variables: { stops: realStops, optimizeWaypoints, ...loadFields },
    });
    if (!response.success) throw new Error(response.error || 'Error creating shipping load');

    this.invalidateShippingLoads(); // derived car shipping status reads this
    return { ...response.load, id: response.loadId || response.load?.id };
  };

  // Undo the shipping_complete flag the load selector sets when it hands off a
  // selection. Used when the load it was meant for could not be created —
  // otherwise those cars leave the needs-shipping list with no load to show for
  // it. Same shape ShippingStatusChip writes when a car is un-shipped.
  unmarkDealsShipped = async (dealIds = []) => {
    await Promise.all(dealIds.map(id => firebase.firestore().doc(`deals/${id}`).set(
      { shipping_complete: false, shipping_status: '' }, { merge: true },
    )));
    this.invalidateShippingLoads();
  };

  // Every load this car has ever sat on — inbound pickups and customer
  // deliveries, cancelled loads included — newest first. Each entry is
  // { loadId, load, stop }. Shares the session-cached index, so this costs no
  // extra reads. Returns [] for a car that has never been on a load.
  getLoadHistoryForCar = async (stock, force = false) => {
    if (!stock) return [];
    const { history } = await this.loadStopIndex(force);
    return history.get(stock) || [];
  };

  // Remember a shipping estimate on the car so the Transport tab can recall it
  // without paying for another Pricing Insights request. Newest first, capped —
  // CarModal's live onSnapshot on cars/{stock} pushes the field straight back
  // into the open modal, so there is nothing to refresh by hand.
  //
  // Entries dedupe on `entry.key` (lane + vehicle signature) so re-running the
  // same quote updates that entry and moves it to the front, instead of piling
  // up a log of button presses.
  //
  // Runs in a transaction: two people estimating the same car with a plain
  // read-modify-write would drop one of the two entries.
  SHIPPING_ESTIMATE_LIMIT = 10;

  recordShippingEstimate = async (stock, entry) => {
    if (!stock || !entry || !entry.key) return;
    const ref = firebase.firestore().doc(`cars/${stock}`);
    await firebase.firestore().runTransaction(async (tx) => {
      const snap = await tx.get(ref);
      const existing = (snap.exists && snap.data().shipping_estimates) || [];
      const kept = existing.filter(e => e && e.key !== entry.key);
      tx.set(ref, {
        shipping_estimates: [entry, ...kept].slice(0, this.SHIPPING_ESTIMATE_LIMIT),
      }, { merge: true });
    });
  };

  // The most-recent non-cancelled drop-off load for this car, or null.
  getDropoffLoadForCar = async (stock) => {
    if (!stock) return null;
    const index = await this.loadDropoffIndex();
    return (index.get(stock) || {}).load || null;
  };

  // Resolves to { status, load } where status is one of
  // constants.car_shipping_statuses and load is the drop-off load (or null).
  // `deal` is optional and only used for the legacy fallback below.
  getShippingInfo = async (stock, deal = null) => {
    const load = await this.getDropoffLoadForCar(stock);
    let status;
    if (load) {
      if (load.status === 'completed') status = 'delivered';
      else if (load.status === 'in_progress') status = 'en_route';
      else status = 'on_load'; // 'pending' or 'posted' (cancelled loads excluded from index)
    } else if (deal && deal.shipping_complete === true) {
      // Legacy fallback: cars shipped before the load system was wired up still
      // carry the old shipping_complete boolean. Treat those as delivered so
      // existing reports don't regress. No backfill required.
      status = 'delivered';
    } else {
      status = 'not_shipped';
    }
    return { status, load };
  };

  // Convenience: just the derived status string.
  getShippingStatus = async (stock, deal = null) => (await this.getShippingInfo(stock, deal)).status;

  // ── Shipping-IN (inbound cars) ────────────────────────────────────────────
  // An inbound car is one Skyway has acquired that has not physically arrived
  // yet — a car doc with sub_status 'inbound'. It ships the opposite direction
  // from a sold car: pick it up at the consignor's address, drop it at the lot
  // named by the car's `location`. There is no deal, so nothing here reads or
  // writes the deals collection.
  getInboundCars = async () => {
    const db = firebase.firestore();
    const [snap, { pickups }] = await Promise.all([
      db.collection('cars').where('sub_status', '==', 'inbound').get(),
      this.loadStopIndex(),
    ]);

    const cars = snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      // Already scheduled for pickup on a live load — nothing left to assign.
      // pickup_not_needed is set by "Remove from map" in the Load Selector.
      .filter(car => !['sold', 'terminated'].includes(car.status)
        && !pickups.has(car.id) && !car.pickup_not_needed);

    // One read per distinct consignor for the pickup address.
    const consignorIds = [...new Set(cars.map(car => car.consignor).filter(Boolean))];
    const consignorDocs = await Promise.all(consignorIds.map(id => db.doc(`customers/${id}`).get()));
    const consignors = new Map(consignorDocs.map(doc => [doc.id, doc.data() || {}]));

    return cars.map(car => {
      const consignor = consignors.get(car.consignor) || {};
      return {
        id: car.id,
        kind: 'inbound',
        car: {
          title: [car.year, car.make, car.model].filter(Boolean).join(' '),
          thumbnail: car.thumbnail || null,
          vin: car.vin || '',
        },
        // Same shape the sold-car list uses so the Load Selector renders both.
        customer: {
          name: [consignor.first_name, consignor.last_name].filter(Boolean).join(' ') || 'Consignor not set',
          address1: consignor.address1 || '',
          city: consignor.city || '',
          state: consignor.state || '',
          zip: consignor.zip || '',
          phone_number: consignor.phone_number || '',
          email: consignor.email || '',
        },
        consignorId: car.consignor || null,
        destination: car.location || null,
        date: car.date || null,
        sub_status_time: car.sub_status_time || null,
      };
    });
  };

  // Create a car that is on its way in. Mirrors the backend check-in flow
  // (status intake / sub_status inbound) and takes the next stock number from
  // admin/counters in a transaction so two users can't claim the same one.
  createInboundCar = async ({ vin = '', year = '', make = '', model = '', color = '', location = 'FL', consignor = null }) => {
    const db = firebase.firestore();
    const today = moment().format('YYYY/MM/DD');
    let stock;
    let carDoc;

    await db.runTransaction(async (tx) => {
      const counterRef = db.doc('admin/counters');
      const counter = await tx.get(counterRef);
      const n = counter.data().lastStock + 1;
      stock = 'SN' + n.toString();

      carDoc = {
        stock,
        vin: vin.trim().toUpperCase(),
        year: year ? parseInt(year, 10) : '',
        make: make.trim(),
        model: model.trim(),
        color: color.trim(),
        status: 'intake',
        status_time: today,
        sub_status: 'inbound',
        sub_status_time: today,
        date: today,
        location,
        inDA: false,
        ...(consignor ? { consignor } : {}),
      };

      tx.set(db.doc(`cars/${stock}`), carDoc);
      tx.update(counterRef, { lastStock: n });
    });

    return { stock, car: carDoc };
  };

  // ---- Funding Performance report ----------------------------------------
  // Funding fields (fundingStatus/fundingTotal/fundingDeposits/fundingBalance/
  // fundingBaseDate/fundingDisplay) are precomputed server-side by the
  // skyway-functions `funding` triggers + twice-daily sweep, so these are cheap
  // single-collection reads with no per-row joins.
  getUnfundedDeals = async () => {
    const snap = await firebase.firestore().collection('deals')
      .where('fundingStatus', '==', 'unfunded').get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  getUnfundedServiceOrders = async () => {
    const snap = await firebase.firestore().collection('orders')
      .where('status', '==', 'payment').get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  };

  getUnfundedLoads = async () => {
    // Departed/completed loads whose deposits don't yet cover the shipping charges.
    const snap = await firebase.firestore().collection('shipping-loads')
      .where('status', 'in', ['in_progress', 'completed']).get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(l => l.deposit_complete !== true);
  };

  // All services with a mechanic-submitted time awaiting review. Each is
  // hydrated with its SO's car title + customer name for a friendly group
  // header. Caller groups by `order` and sorts by SO value.
  getPendingTimeSubmissions = async () => {
    const db = firebase.firestore();
    const snap = await db.collection('services')
      .where('time_submission_status', '==', 'pending').get();
    return this.hydrateTimeSubmissions(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  // Hydrate raw pending-time-submission service docs with SO → car title +
  // customer name. Shared by the one-time fetch and the realtime subscription.
  hydrateTimeSubmissions = async (services) => {
    const db = firebase.firestore();
    if (!services.length) return [];

    // Hydrate SO → car title + customer name, chunked to respect the
    // documentId() `in` limit of 10.
    const orderIds = [...new Set(services.map(s => s.order).filter(Boolean))];
    const orders = {};
    for (let i = 0; i < orderIds.length; i += 10) {
      const chunk = orderIds.slice(i, i + 10);
      const oSnap = await db.collection('orders')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      oSnap.docs.forEach(d => { orders[d.id] = d.data() || {}; });
    }

    const carStocks = [...new Set(Object.values(orders).map(o => o.car).filter(Boolean))];
    const cars = {};
    for (let i = 0; i < carStocks.length; i += 10) {
      const chunk = carStocks.slice(i, i + 10);
      const cSnap = await db.collection('cars')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      cSnap.docs.forEach(d => { cars[d.id] = d.data() || {}; });
    }

    const custIds = [...new Set(Object.values(orders).map(o => o.customer).filter(Boolean))];
    const customers = {};
    for (let i = 0; i < custIds.length; i += 10) {
      const chunk = custIds.slice(i, i + 10);
      const custSnap = await db.collection('customers')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      custSnap.docs.forEach(d => { customers[d.id] = d.data() || {}; });
    }

    return services.map(s => {
      const o = orders[s.order] || {};
      const c = cars[o.car] || {};
      const cust = customers[o.customer] || {};
      const car_title = `${c.year || ''} ${c.make || ''} ${c.model || ''}`.trim();
      const customer_name = (cust.first_name || cust.last_name)
        ? `${cust.first_name || ''} ${cust.last_name || ''}`.trim() : '';
      return { ...s, car_stock: o.car || '', car_title, customer_name };
    });
  };

  // Centralized service field write (approve/reject time submissions, etc.).
  updateServiceFields = (id, updates) =>
    firebase.firestore().collection('services').doc(id).update(updates);

  // Realtime count of services with a mechanic-submitted time awaiting review.
  // Returns the unsubscribe fn. Used for the "Proposed Hours" badge so it stays
  // live as submissions are approved/rejected. `onNew(addedCount)` (optional)
  // fires when new submissions arrive after the first snapshot — for a chime.
  subscribePendingTimeSubmissionCount = (callback, onNew) => {
    let seeded = false;
    return firebase.firestore().collection('services')
      .where('time_submission_status', '==', 'pending')
      .onSnapshot(snap => {
        callback(snap.size);
        // The first snapshot reports every existing doc as "added" — seed and
        // skip so we only chime for genuinely new arrivals.
        if (!seeded) { seeded = true; return; }
        if (onNew) {
          const added = snap.docChanges().filter(c => c.type === 'added').length;
          if (added > 0) onNew(added);
        }
      }, () => callback(0));
  };

  // Realtime count of service orders still awaiting review (status "new"), i.e.
  // freshly created SOs a human hasn't graduated to "estimate" yet. Returns the
  // unsubscribe fn. Powers the "New" badge on the Service menu item and the
  // Mechanic Queue, staying live as SOs are created and graduated.
  subscribeNewServiceOrderCount = (callback) =>
    firebase.firestore().collection('orders')
      .where('status', '==', 'new')
      .onSnapshot(snap => callback(snap.size), () => callback(0));

  // Realtime count of leads still awaiting first contact (status "pending
  // contact" or unset). Powers the "New" badge on the Leads menu item. Scoped to
  // the current rep unless they're backoffice/admin (who see the whole board),
  // mirroring the LeadsPage authorization filter. Returns the unsubscribe fn.
  subscribeNewLeadsCount = (callback, { userID, isBackoffice } = {}) =>
    firebase.firestore().collection('leads')
      .where('status', 'in', ['pending contact', null])
      .onSnapshot(snap => {
        const docs = snap.docs.filter(d => isBackoffice || d.data().sales_id === userID);
        callback(docs.length);
      }, () => callback(0));

  // Realtime count of leads whose follow-up date is due (on or before today) and
  // that are still open (not won/dead/car sold - other buyer). Powers the follow-up badge. Scoped to the
  // current rep unless backoffice/admin. Returns the unsubscribe fn.
  subscribeLeadsNeedingFollowupCount = (callback, { userID, isBackoffice } = {}) => {
    const today = moment().format('YYYY-MM-DD');
    return firebase.firestore().collection('leads')
      .where('nextFollowUp', '<=', today)
      .onSnapshot(snap => {
        const docs = snap.docs.filter(d => {
          const l = d.data();
          if (l.status === 'won' || l.status === 'dead' || l.status === CAR_SOLD_OTHER_BUYER) return false;
          return isBackoffice || l.sales_id === userID;
        });
        callback(docs.length);
      }, () => callback(0));
  };

  // Realtime list of pending time submissions, hydrated with car/customer info.
  // Returns the unsubscribe fn. Used by the Proposed Hours modal so the list
  // updates live as managers review and as new submissions come in.
  subscribePendingTimeSubmissions = (callback) =>
    firebase.firestore().collection('services')
      .where('time_submission_status', '==', 'pending')
      .onSnapshot(async snap => {
        const raw = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        try {
          callback(await this.hydrateTimeSubmissions(raw));
        } catch (e) {
          callback([]);
        }
      }, () => callback([]));

  // ─── Parts approval ───────────────────────────────────────────────────────
  // Parts live as top-level docs in the `parts` collection, each linked to its
  // SO via the `order` field. A part awaiting approval is status === 'pending'
  // (declined parts move to their own 'declined' status, so they're excluded).

  // Realtime list of pending parts, hydrated with SO / car / customer info so
  // the approval modal can group and label them, and the badge can count them.
  // Returns the unsubscribe fn.
  //
  // Scoped to match the Parts Dashboard: only parts whose order is *past*
  // "estimate" belong in the pipeline (ready → complete). This drops pending
  // parts stranded on new/estimate, deleted, or legacy-status orders — so the
  // queue's count agrees with the dashboard instead of counting every part ever.
  subscribePendingParts = (callback) =>
    firebase.firestore().collection('parts')
      .where('status', '==', 'pending')
      .onSnapshot(async snap => {
        const raw = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        try {
          const hydrated = await this.hydrateParts(raw);
          const estimateIdx = constants.order_statuses.indexOf('estimate');
          callback(hydrated.filter(p => {
            const idx = constants.order_statuses.indexOf(p.order_status);
            return idx > estimateIdx;
          }));
        } catch (e) {
          callback([]);
        }
      }, () => callback([]));

  // Attach SO / car / customer context to a list of part docs (keyed off each
  // part's `order` field). Mirrors hydrateTimeSubmissions.
  hydrateParts = async (parts) => {
    const db = firebase.firestore();
    if (!parts.length) return [];

    const orderIds = [...new Set(parts.map(p => p.order).filter(Boolean))];
    const orders = {};
    for (let i = 0; i < orderIds.length; i += 10) {
      const chunk = orderIds.slice(i, i + 10);
      const oSnap = await db.collection('orders')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      oSnap.docs.forEach(d => { orders[d.id] = d.data() || {}; });
    }

    const carStocks = [...new Set(Object.values(orders).map(o => o.car).filter(Boolean))];
    const cars = {};
    for (let i = 0; i < carStocks.length; i += 10) {
      const chunk = carStocks.slice(i, i + 10);
      const cSnap = await db.collection('cars')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      cSnap.docs.forEach(d => { cars[d.id] = d.data() || {}; });
    }

    const custIds = [...new Set(Object.values(orders).map(o => o.customer).filter(Boolean))];
    const customers = {};
    for (let i = 0; i < custIds.length; i += 10) {
      const chunk = custIds.slice(i, i + 10);
      const custSnap = await db.collection('customers')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      custSnap.docs.forEach(d => { customers[d.id] = d.data() || {}; });
    }

    const hydrated = parts.map(p => {
      const o = orders[p.order] || {};
      const c = cars[o.car] || {};
      const cust = customers[o.customer] || {};
      const car_title = `${c.year || ''} ${c.make || ''} ${c.model || ''}`.trim();
      const customer_name = (cust.first_name || cust.last_name)
        ? `${cust.first_name || ''} ${cust.last_name || ''}`.trim() : '';
      return { ...p, car_stock: o.car || '', car_title, customer_name, order_status: o.status || '' };
    });
    return this.attachServiceLineIssues(hydrated);
  };

  // Open service lines on an SO, for the "Service line" picker when a part is
  // requested. Returns [{ id, name }] sorted by name.
  getOpenServiceLines = async (orderId) => {
    if (!orderId) return [];
    const snap = await firebase.firestore().collection('services').where('order', '==', orderId).get();
    return snap.docs
      .filter(d => isOpenServiceLine(d.data()))
      .map(d => ({ id: d.id, name: d.data().name || '(unnamed line)' }))
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  // Add `serviceLineIssue` ('none' | 'closed' | null) to each part by reading
  // the service lines the parts link to. Parts without a serviceId field
  // predate the link and are never flagged.
  attachServiceLineIssues = async (parts) => {
    const db = firebase.firestore();
    const ids = [...new Set(parts.map(p => p.serviceId).filter(Boolean))];
    const lines = {};
    for (let i = 0; i < ids.length; i += 10) {
      const chunk = ids.slice(i, i + 10);
      const snap = await db.collection('services')
        .where(firebase.firestore.FieldPath.documentId(), 'in', chunk).get();
      snap.docs.forEach(d => { lines[d.id] = d.data() || {}; });
    }
    return parts.map(p => ({ ...p, serviceLineIssue: serviceLineIssue(p, lines[p.serviceId]) }));
  };

  // Approve parts: flip status → 'approved' and stamp the approval date. Matches
  // the write the Parts Dashboard makes. Accepts one id or an array.
  approveParts = async (partIds) => {
    const ids = (Array.isArray(partIds) ? partIds : [partIds]).filter(Boolean);
    if (!ids.length) return;
    const now = moment().format('YYYY/MM/DD');
    const batch = firebase.firestore().batch();
    ids.forEach(id => batch.update(
      firebase.firestore().collection('parts').doc(id),
      { status: 'approved', status_time: now, updated_at: firebase.firestore.FieldValue.serverTimestamp() },
    ));
    await batch.commit();
  };

  // Decline parts: terminal 'declined' status + boolean, excluded from accounting.
  // `restoreStatus` remembers the prior status so a Reinstate can restore it —
  // these are pending parts, so it's 'pending'. Mirrors PartsBlade's decline.
  // Accepts one id or an array.
  declineParts = async (partIds) => {
    const ids = (Array.isArray(partIds) ? partIds : [partIds]).filter(Boolean);
    if (!ids.length) return;
    const now = moment().format('YYYY/MM/DD');
    const batch = firebase.firestore().batch();
    ids.forEach(id => batch.update(
      firebase.firestore().collection('parts').doc(id),
      {
        declined: true,
        status: 'declined',
        restoreStatus: 'pending',
        status_time: now,
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
      },
    ));
    await batch.commit();
  };

  // ─── Notifications ──────────────────────────────────────────────────────
  // Backed by the `notifications` collection, written by Cloud Function
  // triggers (deposit / load assignment / load date / title arrival). The tray
  // reads the current user's notifications live. We query by `userId` only
  // (no orderBy) so no composite index is required — the list per user is small
  // and we sort/cap client-side.

  // Realtime feed of the signed-in user's notifications, newest first, capped.
  // `onNew(addedCount)` (optional) fires when unread notifications arrive after
  // the first snapshot — used to chime. Returns the unsubscribe fn.
  subscribeNotifications = (callback, onNew) => {
    const uid = StateManager.userID;
    if (!uid) { callback([]); return () => {}; }
    let seeded = false;
    return firebase.firestore().collection('notifications')
      .where('userId', '==', uid)
      .onSnapshot(snap => {
        const list = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
          .slice(0, 50);
        callback(list);
        // First snapshot reports every existing doc as "added" — seed and skip
        // so we only chime for genuinely new arrivals.
        if (!seeded) { seeded = true; return; }
        if (onNew) {
          const added = snap.docChanges()
            .filter(c => c.type === 'added' && c.doc.data().read !== true).length;
          if (added > 0) onNew(added);
        }
      }, () => callback([]));
  };

  markNotificationRead = (id) =>
    firebase.firestore().collection('notifications').doc(id).update({ read: true });

  // Mark a batch of notifications read in one write. Ignores empty input.
  markNotificationsRead = async (ids = []) => {
    const targets = ids.filter(Boolean);
    if (!targets.length) return;
    const db = firebase.firestore();
    const batch = db.batch();
    targets.forEach(id => batch.update(db.collection('notifications').doc(id), { read: true }));
    await batch.commit();
  };

  // Every non-archived user as {id, name, userType}. For pickers that choose
  // people by name — e.g. the Price Strategy reviewer list.
  getAllUsers = async () => {
    const snap = await firebase.firestore().collection('users').get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(u => !u.archived)
      .map(u => ({
        id: u.id,
        name: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
        userType: u.userType || u.type || '',
      }))
      .filter(u => u.name)
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  // ─── Price strategy ─────────────────────────────────────────────────────
  // The strategy itself runs in the `pricing` Cloud Functions module: a weekly
  // cron stages proposals into `price_strategy_runs` and notifies reviewers.
  // Nothing is repriced until someone applies a run from the Price Strategy
  // page, which is what applyPriceStrategyProposals below does.

  // Live feed of the strategy's settings doc. Absent keys fall back to the
  // backend defaults, so an empty doc is valid — callers get `{}` and the
  // backend fills the gaps.
  subscribePriceStrategySettings = (callback) =>
    firebase.firestore().collection('settings').doc('price_strategy')
      .onSnapshot(
        doc => callback(doc.exists ? doc.data() : {}),
        () => callback({}),
      );

  // Live feed of the most recent staged run. Single-field orderBy, so no
  // composite index is needed.
  subscribeLatestPriceStrategyRun = (callback) =>
    firebase.firestore().collection('price_strategy_runs')
      .orderBy('createdAt', 'desc').limit(1)
      .onSnapshot(
        snap => callback(snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() }),
        () => callback(null),
      );

  // Compute proposals without staging or writing anything. `overrides` previews
  // a settings change before it's saved.
  previewPriceStrategy = (overrides = null) =>
    RequestManager.post({
      function: 'previewPriceStrategy',
      variables: overrides ? { settings: overrides } : {},
    });

  // Run the strategy now and stage it, exactly as the weekly cron does.
  stagePriceStrategyRun = () =>
    RequestManager.post({
      function: 'stagePriceStrategyRun',
      variables: { userId: StateManager.userID },
    });

  // Settings go through the backend so the numbers the unattended scheduler
  // reads are validated in exactly one place.
  savePriceStrategySettings = (settings) =>
    RequestManager.post({
      function: 'savePriceStrategySettings',
      variables: { settings, userId: StateManager.userID },
    });

  // Apply chosen proposals: write the new price, append to price_history, and
  // keep Algolia in sync — the same fields a manual price edit in the Car Modal
  // writes. Firestore batches cap at 500 writes, so we chunk.
  applyPriceStrategyProposals = async (runId, proposals = []) => {
    const targets = (proposals || []).filter(p => p && p.stock && p.newPrice > 0);
    if (!targets.length) return { applied: 0 };

    const db = firebase.firestore();
    const today = moment().format('YYYY/MM/DD');

    // price_history is [{price, date}], newest last, one entry per day. Seed it
    // with the pre-reduction price when a car has no history yet, so the drop
    // reads as a change rather than appearing out of nowhere.
    const buildHistory = (car, newPrice) => {
      let entries = Array.isArray(car.price_history) && car.price_history.length
        ? [...car.price_history]
        : [{ price: car.price || 0, date: car.status_time || today }];
      entries = entries.filter(entry => entry.date !== today);
      entries.push({ price: newPrice, date: today });
      return entries;
    };

    // Read each car fresh rather than trusting the run's snapshot — a run can
    // be hours old and someone may have repriced by hand since it was staged.
    const docs = await Promise.all(targets.map(p =>
      db.collection('cars').doc(String(p.stock)).get()));

    const applied = [];
    const skipped = [];
    docs.forEach((doc, i) => {
      const p = targets[i];
      if (!doc.exists) { skipped.push({ stock: p.stock, reason: 'Car no longer exists' }); return; }
      const car = { ...doc.data(), stock: doc.id };
      if (Number(car.price) !== Number(p.price)) {
        skipped.push({ stock: p.stock, reason: `Price changed to $${Number(car.price).toLocaleString()} since this run` });
        return;
      }
      applied.push({ ...p, history: buildHistory(car, p.newPrice) });
    });

    for (let i = 0; i < applied.length; i += 400) {
      const chunk = applied.slice(i, i + 400);
      const batch = db.batch();
      chunk.forEach(p => batch.set(
        db.collection('cars').doc(String(p.stock)),
        { price: p.newPrice, price_history: p.history, priceUpdated: true },
        { merge: true },
      ));
      await batch.commit();
    }

    if (runId) await this.recordPriceStrategyOutcome(runId, applied.map(p => p.stock), []);
    return { applied: applied.length, skipped };
  };

  // Dismiss proposals — a "no, leave this one alone" that keeps the row out of
  // the pending list without changing a price.
  dismissPriceStrategyProposals = (runId, stocks = []) =>
    this.recordPriceStrategyOutcome(runId, [], stocks);

  // Record what a reviewer did with a run and close it out once every proposal
  // has been either applied or dismissed.
  recordPriceStrategyOutcome = async (runId, appliedStocks = [], dismissedStocks = []) => {
    if (!runId) return;
    const ref = firebase.firestore().collection('price_strategy_runs').doc(runId);
    const update = {
      reviewedBy: StateManager.userID || null,
      reviewedAt: moment().unix(),
    };
    if (appliedStocks.length) {
      update.appliedStocks = firebase.firestore.FieldValue.arrayUnion(...appliedStocks.map(String));
    }
    if (dismissedStocks.length) {
      update.dismissedStocks = firebase.firestore.FieldValue.arrayUnion(...dismissedStocks.map(String));
    }
    await ref.set(update, { merge: true });

    // Re-read to decide the run's status from the authoritative doc rather than
    // from what this client happened to know.
    const snap = await ref.get();
    if (!snap.exists) return;
    const run = snap.data();
    const handled = new Set([...(run.appliedStocks || []), ...(run.dismissedStocks || [])]);
    const total = (run.proposals || []).length;
    const status = handled.size === 0 ? 'pending'
      : handled.size >= total ? 'complete'
        : 'partial';
    if (run.status !== status) await ref.set({ status }, { merge: true });
  };

  // ─── Inventory feed health ──────────────────────────────────────────────
  // `feed-status` holds one rollup doc per feed and `feed-runs` the per-run
  // history, both written by the runFeed wrapper in the Cloud Functions. The
  // rollup is what makes the page cheap: one document per feed, live.

  subscribeFeedStatus = (callback) =>
    firebase.firestore().collection('feed-status')
      .onSnapshot(
        snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
        () => callback([]),
      );

  // Recent runs for one feed, newest first. Filters on `key` alone and sorts
  // client-side so no composite index is needed — history is capped per feed.
  getFeedRuns = async (key, limit = 20) => {
    const snap = await firebase.firestore().collection('feed-runs')
      .where('key', '==', key)
      .get();
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (b.startedAt || 0) - (a.startedAt || 0))
      .slice(0, limit);
  };

  // Force one feed to run now — the same work the nightly schedule performs.
  runFeedNow = async (key) =>
    RequestManager.get({ function: 'runFeedNow', variables: { key } });

  // Run the failure check on demand, instead of waiting for 3:30 AM.
  checkFeedsNow = async () =>
    RequestManager.get({ function: 'checkFeedsNow', variables: {} });

  // ─── Car video pipeline ─────────────────────────────────────────────────
  // The reformatVideos and uploadYoutubeVideo crons keep retry state on each
  // car (see utilities/videoPipeline.js). Retry clears the wait so the next
  // run, at most a few minutes away, tries again.

  // Starts the clip over: attempt count, fallback profile and status all reset
  retryVideoClip = async (stock, key) =>
    firebase.firestore().doc(`cars/${stock}`).update({
      [`video_reformat_attempts.${key}`]: firebase.firestore.FieldValue.delete(),
      [`${key}_status`]: firebase.firestore.FieldValue.delete(),
    });

  retryVideoUpload = async (stock) =>
    firebase.firestore().doc(`cars/${stock}`).update({ 'video_upload.next_attempt_at': null });

  // Everything the Feed Health "Videos" section shows, in one read
  getVideoPipelineHealth = async () => {
    const db = firebase.firestore();
    const [counters, ...snaps] = await Promise.all([
      db.doc('admin/counters').get(),
      db.collection('cars').where('status', '==', 'active').get(),
      ...['sales review', 'write-up', 'video'].map(s => db.collection('cars').where('sub_status', '==', s).get()),
    ]);
    const cars = new Map();
    snaps.forEach(snap => snap.docs.forEach(d => cars.set(d.id, { ...d.data(), id: d.id })));
    return { counters: counters.data() || {}, cars: [...cars.values()] };
  };

  // Upload an image and set it as the car's thumbnail — used to quickly give an
  // imageless car a photo (e.g. from the service order). Mirrors the marketing
  // upload convention: compressed image in the public CDN bucket, thumbnail
  // stored as a full CDN URL. Returns the URL.
  setCarThumbnailFromFile = async (stock, file) => {
    if (!stock || !file) return null;
    const PUBLIC_BUCKET = 'skyway-dev-373d5';
    const CDN_BASE = 'https://cdn.skywayclassics.com/';
    let compressed = file;
    try { compressed = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1920 }); } catch (e) { /* fall back to original */ }
    const ext = (file.name && file.name.includes('.')) ? file.name.split('.').pop() : 'jpg';
    const filename = `images/${uuidv4()}.${ext}`;
    await firebase.app().storage(PUBLIC_BUCKET).ref(filename).put(compressed);
    const url = CDN_BASE + filename;
    await firebase.firestore().doc('cars/' + stock).set({ thumbnail: url, picsRefreshed: true }, { merge: true });
    return url;
  };

  // ─── Phone controller (shop-line SMS) ───────────────────────────────────
  // Threads and messages are written by skyway-functions phoneSmsInbound /
  // phoneSendSms. The browser never calls Twilio. A listener error reports
  // an empty list so the page can render without throwing.

  subscribePhoneThreads = (callback) =>
    firebase.firestore().collection('threads')
      .where('source', '==', PHONE_SOURCE)
      .onSnapshot(
        snap => callback(sortThreads(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })))),
        () => callback([], true),
      );

  subscribePhoneMessages = (threadId, callback) => {
    if (!threadId) return () => {};
    return firebase.firestore().collection('messages')
      .where('threadId', '==', threadId)
      .onSnapshot(
        snap => callback(snap.docs.map(doc => ({ id: doc.id, messageId: doc.id, ...doc.data() }))),
        () => callback([], true),
      );
  };

  // Missed inbound calls written by phoneMissedCall (PHONE-A2) on
  // phone_callbacks. PHONE-A1 does not store answered or outbound calls, so
  // an empty snapshot is the whole history. No softphone token is involved.
  subscribePhoneCalls = (threadId, callback) => {
    if (!threadId) return () => {};
    return firebase.firestore().collection('phone_callbacks')
      .where('threadId', '==', threadId)
      .onSnapshot(
        snap => callback(callsForThread(
          snap.docs.map(doc => ({ id: doc.id, ...doc.data() })),
          threadId,
        )),
        () => callback([], true),
      );
  };

  // SLED-088 callback queue. Open phone_callbacks rows across all numbers.
  // Clients can read but not write phone_callbacks; Done goes through
  // phoneCallbackStatus and new rows through phoneEnqueueCallback.
  subscribePhoneCallbackQueue = (callback) =>
    firebase.firestore().collection('phone_callbacks')
      .where('status', '==', 'open')
      .limit(200)
      .onSnapshot(
        snap => callback(callbackQueueRows(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })))),
        () => callback([], true),
      );

  setPhoneCallbackStatus = (callbackId, status) =>
    RequestManager.post({ function: 'phoneCallbackStatus', variables: { callbackId, status } });

  enqueuePhoneCallback = (variables) =>
    RequestManager.post({ function: 'phoneEnqueueCallback', variables });

  markPhoneThreadRead = (threadId) => {
    if (!threadId) return Promise.resolve();
    return firebase.firestore().collection('threads').doc(threadId).set(
      { hasUnread: false },
      { merge: true },
    );
  };

  // Sales floor awareness. userType and type are both used on live user docs.
  // This does not change IVR ringing.
  subscribeSalesRoster = (callback) => {
    const db = firebase.firestore();
    let byUserType = null;
    let byType = null;
    const emit = () => {
      if (!byUserType || !byType) return;
      const byId = new Map();
      [...byUserType, ...byType].forEach(doc => {
        byId.set(doc.id, rosterPerson({ id: doc.id, ...doc.data() }));
      });
      callback(
        [...byId.values()]
          .filter(person => !person.archived && person.name)
          .sort((a, b) => a.name.localeCompare(b.name)),
      );
    };
    const unsubType = db.collection('users').where('userType', '==', 'sales').onSnapshot(
      snap => { byUserType = snap.docs; emit(); },
      () => { byUserType = []; emit(); },
    );
    const unsubRole = db.collection('users').where('type', '==', 'sales').onSnapshot(
      snap => { byType = snap.docs; emit(); },
      () => { byType = []; emit(); },
    );
    return () => {
      unsubType();
      unsubRole();
    };
  };

  setMyPhonePresence = async (status) => {
    const uid = StateManager.userID;
    if (!uid) throw new Error('Not signed in');
    if (status !== 'available' && status !== 'away') throw new Error('Unknown status');
    await firebase.firestore().collection('users').doc(uid).set({
      phonePresence: status,
      phonePresenceAt: firebase.firestore.FieldValue.serverTimestamp(),
    }, { merge: true });
  };

  sendPhoneSms = (variables) =>
    RequestManager.post({ function: 'phoneSendSms', variables });

  // PHONE-A3 phoneVoiceToken. Firebase ID token via RequestManager. Identity
  // is skyway_{uid} (Twilio address client:skyway_{uid}). Body uid is ignored.
  // Outbound audio is phoneVoiceClient (TwiML App), which reads To.
  // A missing function returns { success: false } and must not throw.
  fetchPhoneVoiceToken = () =>
    RequestManager.post({ function: 'phoneVoiceToken', variables: {} });

  // Phone context. lookupLeadsByPhone is the leads_lookup_by_phone read.
  // searchCustomers is the customer read (Algolia). Neither returns service
  // orders. The page filters customer hits to an exact phone match.
  lookupLeadsByPhone = (phone) =>
    RequestManager.post({ function: 'lookupLeadsByPhone', variables: { phone } });

  searchCustomers = (query) =>
    RequestManager.post({ function: 'searchCustomers', variables: { query, limit: 15 } });
}

const store = new Store();
export default store;

const getActiveStockNumbers = () => [
  {value:'123-FL', label: '123-FL'},
  {value:'940-FL', label: '940-FL'},
  {value:'1924-FL', label: '1924-FL'},
].sort((f, s) => f.value < s.value ? -1 : 1);

const getNextStockNumber = async ( input = {setter: () => null} ) => {
  const carSettings = await firebase.firestore().collection(`admin`).doc('car_settings').get();
  let nextStockNumber = carSettings.data().lastStock + 1
  input.setter(nextStockNumber)
  return nextStockNumber
}

const increaseLastStockNumber = async () => {
  await firebase.firestore().collection(`admin`).doc('car_settings').update({lastStock: firebase.firestore.FieldValue.increment(1)});
}

const getActiveExpenseAccounts = () => [
  {value:'marketing', label: 'Marketing'},
  {value:'bank', label: 'Bank Fees'},
  {value:'commissions', label: 'Commissions'},
  {value:'contractors', label: 'Contractors'},
  {value:'tolls', label: 'Tolls'},
  {value:'legal', label: 'Legal Services'},
  {value:'meals', label: 'Meals'},
  {value:'office', label: 'Office/Shop Supplies'},
  {value:'reimburse', label: 'Reimbursable Expenses'},
  {value:'mortgage', label: 'Mortgage Interest'},
  {value:'salaries', label: 'Salaries & Wages'},
  {value:'shipping', label: 'Shipping'},
  {value:'taxes', label: 'Taxes'},
  {value:'towing', label: 'Towing'},
  {value:'travel', label: 'Travel'},
  {value:'utilities', label: 'Utilities'},
  {value:'fuel', label: 'Fuel'},
  {value:'uncategorized', label: 'Uncategorized'},
  {value:'repair', label: 'Repair'},
  {value:'inventory', label: 'Inventory Purchase'},
].sort((f, s) => f.value < s.value ? -1 : 1);

const getActivePaymentTypes = () => [
  // {value:'cash', label: 'Cash'}, 
  {value:'check', label: 'Check'}, 
  // {value:'credit', label: 'Credit'}, 
  {value:'wire', label: 'Wire'}, 
];

const getBanks = async () => {
  const bankSnapshot = await firebase.firestore().collection(`banks`).get();
  return bankSnapshot.docs.map(doc => {
    const data = doc.data();
    return {
      label: data.name,
      value: data,
    }
  });
};

const forms = {
  purchase: {
    inputs: [
      {type: 'select', id: 'account', label: 'Account', selections: [...getActiveExpenseAccounts()],
        conditionals: [
          {
            id: 'account',
            value: 'repair',
            inputs: [
              {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true} // requiredselections: [...getActiveStockNumbers()]},
            ]
          },
          {
            id: 'account',
            value: 'inventory',
            inputs: [
              {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true} // requiredselections: [...getActiveStockNumbers()]},
            ]
          },
        ]
      },
      {type: 'select', id: 'payment', label: 'Payment Type', selections: getActivePaymentTypes(), 
        conditionals: [
          {
            id: 'payment',
            value: 'wire',
            inputs: [
              {type: 'text', id: 'address', label: 'Recipient Address', inputType:"text", required: true},
              {type: 'text', id: 'routing', label: 'Routing Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true},
              {type: 'text', id: 'accountNum', label: 'Account Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true},
            ]
          },
          {
            id: 'payment',
            value: 'check',
            inputs: [
              {type: 'select', id: 'bank', label: 'Bank Account', selections: getBanks},
            ]
          },
        ]
      },
      {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true},
      {type: 'text', id: 'vendor', label: 'Recipient', inputType:"text", required: true},
      {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
    ], 
    action: store.uploadRequest,
    collection: 'purchases',
    title: 'Payment Request'
  },
  expense: {
    inputs: [
      {type: 'select', id: 'account', label: 'Account', selections: [...getActiveExpenseAccounts()], 
        conditionals: [
          {
            id: 'account',
            value: 'repair',
            inputs: [
              {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true} // requiredselections: [...getActiveStockNumbers()]},
            ]
          },
          {
            id: 'account',
            value: 'inventory',
            inputs: [
              {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true} // requiredselections: [...getActiveStockNumbers()]},
            ]
          },
        ]
      },
      {type: 'text', id: 'amount', label: 'Amount', inputType:"tel", mask:cleanNumber, required: true},
      // {type: 'text', id: 'vendor', label: 'Vendor', inputType:"text", required: true},
      {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
      {type: 'file', id: 'receipt', label: 'Receipt', required: false},
    ],
    action: store.uploadForm,
    collection: 'purchases',
    title: 'Record Receipt'
  },
  trade: {
    inputs: [
      {type: 'text', id: 't', label: 'id', required: true, visible:false},
      {type: 'text', id: 'stock', label: 'Selling Car Stock Number', inputType:"tel",  required: true, disabled:true},
      {type: 'text', id: 'year', label: 'Year', inputType:"number", required: true},
      {type: 'text', id: 'make', label: 'Make', inputType:"text", required: true},
      {type: 'text', id: 'model', label: 'Model', inputType:"text", required: true},
      {type: 'text', id: 'vin', label: 'VIN', inputType:"text", required: true},
      {type: 'text', id: 'trade', label: 'Trade Amount', inputType:"number", mask:cleanNumber,  required: true},
      {type: 'text', id: 'payoff', label: 'Payoff Amount', inputType:"number", mask:cleanNumber,  required: true},
      {type: 'text', id: 'netTrade', label: 'Net Trade', inputType:"numeric", required: false, disabled: true},
    ],
    action: store.uploadForm,
    updater: (location) => store.calculate(location, 'netTrade', {trade: '+', payoff: '-'}),
    docID: 't',
    callback: async () => { 
      const url = new URL(window.location.href);
      const tradeID = url.searchParams.get("t");
      const stockNumber = url.searchParams.get("stock");
      const trades = firebase.firestore.FieldValue.arrayUnion(tradeID);
      await firebase.firestore().doc('deals/'+stockNumber).set({trades}, {merge: true});
      return {complete: true}
    },
    onSuccess: (urlParams) => history.push(`/${urlParams.redirect}/${urlParams.stock}?tab=${urlParams.tab}`),
    collection: 'trades', 
    title: 'Add Trade'
  },
  "car-expenses": {
    inputs: [
      {type: 'text', id: 'iterable', label: 'iterable', loadDefault:() => 'expenses', required: true, visible: false},
      {type: 'text', id: 'account', label: 'Account', defaultValue: 'repair', required: true, visible: false},
      {type: 'text', id: 'type', label: 'Type', defaultValue: "sales", required: true, visible: false},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true},
      {type: 'blank'},
      {type: 'array', id: 'expenses', tag:'iterable', items:[
        {type: 'text', id: 'e', label: 'Doc ID', required: true, visible: false},
        {type: 'text', id: 'vendor', label: 'Vendor', inputType:"text", required: true},
        {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true},
        {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
        {type: 'text', id: 'paidDate', label: 'Paid Date', defaultValue: moment().format("YYYY/MM/DD"), disabled:true, required: true, visible: true},
        {type: 'select', id: 'isPayable', label: 'Is Paid?', defaultValue: false, loadDefault:() => false, selections: [{value: false, label: 'Yes'}, {value: true, label: 'No'}], disabled:false},
        {type: 'file', id: 'receipt', label: 'Receipt', required: false},
        // {type: 'blank'},
      ]}
    ],
    action: store.uploadForms,
    updater: store.updatePaidDate,
    arrayDocId: "e",
    secondaryAction: () => null,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'purchases', 
    title: 'Add Expense'
  },
  "edit-expenses": {
    inputs: [
      {type: 'text', id: 'date', label: 'Date', disabled: true, required: true, visible: false},
      {type: 'text', id: 'paidDate', label: 'Paid Date', disabled: false, required: true, visible: true},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true, disabled: false},
      {type: 'text', id: 'e', label: 'Doc ID', required: true, visible: false},
      {type: 'text', id: 'vendor', label: 'Vendor', inputType:"text", required: true},
      {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true},
      {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
      {type: 'select', id: 'isPayable', label: 'Is Paid?', selections: [{value: false, label: 'Yes'}, {value: true, label: 'No'}],},
      {type: 'text', id: 'type', label: 'Type', inputType:"text", disabled: !StateManager.isAdmin(), required: true},
      {type: 'file', id: 'receipt', label: 'Receipt', required: false},
    ],
    action: store.uploadForm,
    updater: store.updatePaidDate,
    docID: "e",
    secondaryAction: () => null,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}${urlParams.redirect?.includes('?') ? '&' : '?'}tab=${urlParams.tab}`),
    collection: 'purchases',
    title: 'Edit Expense'
  },
  "car-deposits": {
    inputs: [
      {type: 'text', id: 'iterable', label: 'iterable', loadDefault:() => 'deposits', required: true, visible: false},
      {type: 'text', id: 'account', label: 'Account', loadDefault:() => 'sales', required: true, visible: false},
      {type: 'text', id: 'type', label: 'Type', defaultValue: "sales", required: true, visible: false},
      {type: 'text', id: 'date', label: 'Date', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true, disabled: true},
      {type: 'blank'},
      {type: 'array', id: 'deposits', tag:'iterable', items:[
        {type: 'select', id: 'account', label: 'Receiving Bank', selections: StateManager.deposit_banks},
        {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true},
        {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
        {type: 'file', id: 'receipt', label: 'Receipt', required: false},
      ]}
    ],
    action: store.uploadForms,
    secondaryAction: () => null,
    updater: () => null,
    callback: async (form) =>{
      const account = form.account;
      if(account === "safe"){
        const deposit = {
          date:  form.date,
          assigned: false,
          source: "sales",
          memo: form.memo,
          amount: form.amount,
          user: form.stock
        }
        await firebase.firestore().collection("cash").doc().set(deposit, {merge: true});
      }

      const type = form.type;
      if(["shipping", "shipping_in", "finance"].includes(type)){
        const memo = form.memo;
        if(memo.includes("TFD")){
          const doc = firebase.firestore().collection("purchases").doc();
          const purchase = {
            date:  form.date,
            paidDate:  form.date,
            stock: form.stock,
            e: doc.id,
            vendor: "Skyway Classics",
            amount: form.amount,
            memo: `TFD - transfer to ${type}`,
            isPayable: false,
            assigned: false,
          }
          await doc.set(purchase, {merge: true});
        }
      }
    },
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'deposits', 
    title: 'Add Deposit'
  },
  "new-customer": {
    inputs: [
      {type: 'text', id: 'customer', label: 'id', required: true, visible:false},
      {type: 'text', id: 'stock', label: 'Stock Number', required: true, visible:false},
      {type: 'text', id: 'first_name', label: 'First Name', inputType:"text", required: true},
      {type: 'text', id: 'last_name', label: 'Last Name', inputType:"text", required: true},
      {type: 'select', id: 'sex', label: 'Sex', selections: StateManager.sexes, required: true},
      {type: 'date', id: 'birthday', label: 'Birthday', required: true},
      {type: 'text', id: 'email', label: 'Email', inputType:"text", required: true},
      {type: 'text', id: 'phone_number', label: 'Phone Number', inputType:"tel", required: true},
      {type: 'text', id: 'address1', label: 'Address', inputType:"text", required: true},
      {type: 'text', id: 'city', label: 'City', inputType:"text", required: true},
      {type: 'select', id: 'state', label: 'State', selections: StateManager.states, required: true},
      {type: 'text', id: 'zip', label: 'Zip Code', inputType:"text", required: true},
      {type: 'text', id: 'dl', label: 'License Number', inputType:"text", required: true},
      // {type: 'file', id: 'license', label: 'License Picture', required: true},
      // {type: 'file', id: 'insurance', label: 'Insurance Picture', required: true},
      {type: 'text', id: 'routing_num', label: 'Routing Number', inputType:"text", required: true},
      {type: 'text', id: 'account_num', label: 'Account Number', inputType:"text", required: true},
    ],
    action: store.addFormWithCallback,
    docID: 'customer',
    folder: 'customer_data',
    // updater: () => null,
    callback: async (form) =>{
      const stockNumber = form.stock
      var url = new URL(window.location.href);
      var type = url.searchParams.get("type");
      var customer = url.searchParams.get("customer");
      const table = url.searchParams.get("table");
      await firebase.firestore().doc(table+'/'+stockNumber).set({[type]: customer}, {merge: true});

      if(type == "consignor"){
        const {first_name = "", last_name = ""} = form;
        const name = first_name + " " + last_name;
        console.log(name, `purchases/${stockNumber}-NTO`)
        await firebase.firestore().doc(`purchases/${stockNumber}-NTO`).set({vendor: name}, {merge: true});
      }
      return {complete: true};
    },
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'customers', 
    title: 'New Customer'
  },
  files: {
    inputs: [
      {type: 'text', id: 'date', label: 'Date', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", disabled: true, required: true, visible: false},
      {type: 'text', id: 'name', label: 'File name', required: true},
      {type: 'blank'},
      {type: 'file', id: 'file', label: 'Upload Files', required: true},
      {type: 'blank'},
    ],
    action: store.uploadFiles,
    secondaryAction: () => null,
    updater: () => null,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'files', 
    title: 'Add Files'
  },
  "deposit-cash": {
    inputs: [
      {type: 'text', id: 'date', label: 'Date', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'select', id: 'source', label: 'Source of Funds', selections: [
        {value: "sales", label: 'Funding Car Sale'},
        {value: "safe", label: 'Safe'}, 
        {value: "pilot", label: 'Pilot'},
        {value: "wells-fargo", label: 'Wells Fargo'},
      ],},
      {type: 'text', id: 'memo', label: 'Memo', required: false, visible: true, disabled: false},
      {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true, disabled: false},
      {type: 'text', id: 'user', label: 'Employee Name', required: false, visible: true, disabled: false},
    ],
    action: async (collection, form) => {
      form.originalAmount = form.amount;
      form.assigned = false;
      return await store.uploadForm(collection, form);
    },
    secondaryAction: () => null,
    updater: () => null,
    onSuccess: (urlParams) => history.push(`/${urlParams.redirect}/${urlParams.stock}?tab=${urlParams.tab}`),
    collection: 'cash', 
    title: 'Deposit Cash'
  },
  "new-lead": {
    inputs: [
      {type: 'text', id: 'c', label: 'id', required: true, visible:false},
      {type: 'text', id: 'first_contact', label: 'first_contact', loadDefault:() => moment().format('YYYY/MM/DD HH:mm'), required: true, visible:false},
      {type: 'text', id: 'last_contact', label: 'last_contact', loadDefault:() => moment().format('YYYY/MM/DD HH:mm'), required: true, visible:false},
      {type: 'text', id: 'contacts', label: 'contacts', loadDefault:() => 0, required: true, visible:false, mask:cleanNumber},
      {type: 'text', id: 'first_name', label: 'First Name', inputType:"text",required: true},
      {type: 'text', id: 'last_name', label: 'Last Name', inputType:"text", required: true},
      {type: 'text', id: 'email', label: 'Email', inputType:"text", required: true},
      {type: 'text', id: 'phone_number', label: 'Phone Number', inputType:"tel", required: true}, //mask:cleanPhoneNumber
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true},
      {type: 'text', id: 'source', label: 'Source', inputType:"text", required: true},
      {type: 'text', id: 'comments', label: 'Comments', inputType:"tel", required: true, multiline: true},
    ],
    action: store.addFormWithCallback,
    docID: 'c',
    // updater: () => null,
    callback: async (form) =>{
      history.push(`/sales-dashboard`);
      return {complete: true};
    },
    collection: 'customers', 
    title: 'Add Lead'
  },
  "add-car": {
    inputs: [
      {type: 'select', id: 'inDA', label: 'In DA?', defaultValue: false, loadDefault:() => false, selections: [{value: false, label: 'No'}, {value: true, label: 'Yes'}], disabled:true, visible: false},
      {type: 'text', id: 'date', label: 'Date', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'status', label: 'Status', loadDefault:() => constants.statuses[0], disabled: true, required: true, visible: false},
      {type: 'text', id: 'status_time', label: 'Status Time', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'sub_status', label: 'Status', loadDefault:() => constants.sub_statuses[0], disabled: true, required: true, visible: false},
      {type: 'text', id: 'sub_status_time', label: 'Status Time', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true, disabled: true, visible:true},
      {type: 'select', id: 'location', label: 'Location', loadDefault:() => "FL", selections: constants.makeSelects("locations"), required: true},
      {type: 'text', id: 'vin', label: 'VIN (optional)', inputType:"text", required: false},
      {type: 'text', id: 'year', label: 'Year', inputType:"text", required: true},
      {type: 'text', id: 'make', label: 'Make', inputType:"text", required: true},
      {type: 'text', id: 'model', label: 'Model', inputType:"text", required: true},
      {type: 'text', id: 'color', label: 'Color', inputType:"text", required: true},
    ],
    action: store.addFormWithStockNumberConcat,
    docID: 'stock',
    // updater: () => null),
    callback: async (form) =>{
      const url = new URL(window.location.href);
      const lastStock = +url.searchParams.get("stock");
      const table = url.searchParams.get("table");
      const service_number = url.searchParams.get("service_number");
      let update = {inDA: false};
      if(table && service_number) {
        await firebase.firestore().doc(table+'/'+service_number).set({car: form.stock}, {merge: true});
        update = {inDA: false, sub_status: "complete", status: "service"};
      }

      await firebase.firestore().doc('cars/'+form.stock).update(update);
      if(service_number) await firebase.firestore().doc('admin/counters').update({lastServiceStock: lastStock});
      else await firebase.firestore().doc('admin/counters').update({lastStock});

      const redirect = url.searchParams.get("redirect");
      if(redirect) history.push(redirect);
      return {complete: true};
    },
    collection: 'cars', 
    title: 'Add New Car'
  },
  "order-parts": {
    inputs: [
      {type: 'text', id: 'date', label: 'Date', loadDefault:() => moment().format('YYYY/MM/DD'), disabled: true, required: true, visible: false},
      {type: 'text', id: 'order', label: 'Order', inputType:"tel", inputProps:{inputmode: 'tel'}, mask:cleanServiceStockNumber, disabled: true, required: true},
      {type: 'text', id: 'service', label: 'Service', required: true, disabled: true, visible: false},
      {type: 'blank'},
      {type: 'text', id: 'name', label: 'Item', inputType:"text", required: true},
      {type: 'text', id: 'vendor', label: 'Vendor', inputType:"text",required: true},
      {type: 'text', id: 'partNumber', label: 'Part Number', inputType:"text",required: true},
      {type: 'text', id: 'link', label: 'Link', inputType:"text", required: true},
      {type: 'select', id: 'status', label: 'Status', loadDefault:() => constants.part_statuses.at(0), selections: constants.makeSelects("part_statuses"), required: true},
      {type: "blank"},
      {type: "blank"},
      {type: "blank"},
      {type: 'date', id: 'orderDate', label: 'Order Date', required: true},
      {type: 'date', id: 'arrivalDate', label: 'Estimated Arrival Date', required: true},
      {type: "blank"},
      {type: "blank"},
      {type: 'text', id: 'cost', label: 'Cost', inputType:"number", mask:cleanNumber, required: true},
      {type: "blank"},
      // {type: 'text', id: 'revenue', label: 'Revenue', inputType:"number", mask:cleanNumber, disabled: !StateManager.isAdmin(), required: true, visible: StateManager.isAdmin()},
      // {type: 'text', id: 'profit', label: 'Profit', mask:cleanNumber, required: false, disabled: true, visible: StateManager.isAdmin()},
      {type: 'file', id: 'receipt', label: 'Receipt', required: false},
    ],
    action: store.uploadForm,
    secondaryAction: () => null,
    // updater: store.calculatePartProfit,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'parts', 
    title: 'Part Request'
  },
  "edit-parts": {
    inputs: [
      {type: 'text', id: 'date', label: 'Date', disabled: true, required: true, visible: false},
      {type: 'text', id: 'order', label: 'Order', inputType:"tel", inputProps:{inputmode: 'tel'}, mask:cleanServiceStockNumber, required: true},
      {type: 'text', id: 'p', label: 'Doc ID', required: true, visible: false},
      {type: 'text', id: 'name', label: 'Item', inputType:"text", required: true},
      {type: 'text', id: 'link', label: 'Link', inputType:"text", required: true},
      {type: 'select', id: 'status', label: 'Status', selections: constants.makeSelects("part_statuses"), required: true},
      {type: "blank"},
      {type: "blank"},
      {type: 'date', id: 'orderDate', label: 'Order Date', required: true},
      {type: 'date', id: 'arrivalDate', label: 'Estimated Arrival Date', required: true},
      {type: "blank"},
      {type: "blank"},
      {type: 'text', id: 'cost', label: 'Cost', inputType:"number", mask:cleanNumber, required: true},
      {type: "blank"},
      // {type: 'text', id: 'revenue', label: 'Revenue', inputType:"number", mask:cleanNumber, disabled: !StateManager.isAdmin(), required: true, visible: false},
      // {type: 'text', id: 'profit', label: 'Profit', mask:cleanNumber, required: false, disabled: true, visible: false},
      {type: 'file', id: 'receipt', label: 'Receipt', required: false},
    ],
    action: store.uploadForm,
    // updater: store.calculatePartProfit,
    docID: "p",
    secondaryAction: () => null,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}${urlParams.redirect?.includes('?') ? '&' : '?'}tab=${urlParams.tab}`),
    collection: 'parts',
    title: 'Edit Part'
  },
  "order-expenses": {
    inputs: [
      {type: 'text', id: 'iterable', label: 'iterable', loadDefault:() => 'expenses', required: true, visible: false},
      {type: 'text', id: 'account', label: 'Account', defaultValue: 'repair', required: true, visible: false},
      {type: 'text', id: 'type', label: 'Type', defaultValue: "sales", required: true, visible: false},
      {type: 'text', id: 'stock', label: 'Stock Number', inputType:"tel", inputProps:{inputmode: 'tel'}, required: true, disabled: true},
      {type: 'blank'},
      {type: 'array', id: 'expenses', tag:'iterable', items:[
        {type: 'text', id: 'e', label: 'Doc ID', required: true, visible: false},
        {type: 'text', id: 'vendor', label: 'Vendor', inputType:"text", required: true},
        {type: 'text', id: 'amount', label: 'Amount', inputType:"number", mask:cleanNumber, required: true},
        {type: 'text', id: 'memo', label: 'Memo', inputType:"text", required: true},
        {type: 'text', id: 'paidDate', label: 'Paid Date', defaultValue: moment().format("YYYY/MM/DD"), disabled:true, required: true, visible: true},
        {type: 'select', id: 'isPayable', label: 'Is Paid?', defaultValue: false, loadDefault:() => false, selections: [{value: false, label: 'Yes'}, {value: true, label: 'No'}], disabled:false},
        {type: 'file', id: 'receipt', label: 'Receipt', required: false},
        // {type: 'blank'},
      ]}
    ],
    action: store.uploadForms,
    updater: store.updatePaidDate,
    arrayDocId: "e",
    secondaryAction: () => null,
    onSuccess: (urlParams) => history.push(`${urlParams.redirect}?tab=${urlParams.tab}`),
    collection: 'purchases', 
    title: 'Add Expense'
  },
};

export function cleanPhoneNumber(text){
  text = text.replace(/\D/g,"");
  let reg = /(\d{3})(\d{3})(\d{4})/;
  var x = text.match(reg);
  if(!x) return text;
  else return '(' + x[1] + ') ' + (x[2] || "") + '-' + (x[3] || "");
}

export function cleanStockNumber(text){
  const url = new URL(window.location.href);
  const post = "-" + (url.searchParams.get("post") || "FL");
  if(text.slice(-2) === post.slice(0,-1)) return text.replace(/\D/g,'').slice(0, -1)+post;
  return text.replace(/\D/g,'')+post;
}

export function cleanServiceStockNumber(text){
  return "SO"+text.replace(/\D/g,'');
}

export function cleanNumber(text){
  text = text.replace(/[^0-9\-.]/g,'');
  if(text !== "") text = Number(text);
  return text;
}

export function cleanBoolean(text, baseline="true"){
  console.log(text, baseline, text === baseline)
  return text === baseline
}

export function cleanDate(text){
  text = moment(text)
  return text.format("MM/DD/YYYY");
}

function base64toPDF(data, name) {
  var bufferArray = base64ToArrayBuffer(data);
  var blobStore = new Blob([bufferArray], { type: "application/pdf" });
  // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //     var fileURL = URL.createObjectURL(blobStore);
  //     window.open(fileURL);
  //     // window.navigator.msSaveBlob(blobStore, name);
  //     return;
  // }
  var data = window.URL.createObjectURL(blobStore);
  var link = document.createElement('a');
  document.body.appendChild(link);
  link.href = data;
  link.download = name;
  link.target="_blank";
  link.click();
  // window.URL.revokeObjectURL(data);
  link.remove();
}

function base64ToArrayBuffer(data) {
  var bString = window.atob(data);
  var bLength = bString.length;
  var bytes = new Uint8Array(bLength);
  for (var i = 0; i < bLength; i++) {
      var ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
  }
  return bytes;
};

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
  console.log(mime);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}


export function parseSearchString(string) {
  string = string.substr(1);
  let list = string.split('&');
  let params = {}
  for (let index = 0; index < list.length; index++) {
    let varString = list[index];
    let [key, value] = varString.split('=');
    params[key] = value;
  }

  return params;
}




// function format(value, pattern) {
//   var i = 0,
//       v = value.toString();
//   return pattern.replace(/#/g, _ => v[i++]);
// }

// console.log(format(123456789, '## ## ## ###'));
